<template>
  <main-layout selectedMenu="explore" :class="{ overHiden: isPhotoBox }">
    <div class="video-container" v-if="type == 3 && !isVideoOpen">
      <div class="video-wrap clearfix">
        <div class="left-container">
          <div class="newLeft">
            <div
              :class="[!isMin ? 'top-left' : 'minVideoPlay']"
              @contextmenu.prevent
            >
              <manaPlayer
                :playerOptions="playerOptions"
                ref="manaPlayer"
                :config="config"
                :isMin="isMin"
                @min="min"
                :relatedVedioList="relatedVedioList"
                :lookList="lookList"
                :recommendVedioList="recommendVedioList"
                :videoId="$query.id"
                :lookId="$query.lookId"
              ></manaPlayer>
            </div>
            <div class="top-bottom">
              <a @click="recommendToSubject" class="add">
                <span class="link-icon link-icon-add"></span>
                {{ $t("global.添加到频道") }}
              </a>
              <a
                href="javascript:;"
                class="download"
                @click="videoMark"
                v-if="videoItem.allowDownload == 1"
              >
                <span class="link-icon link-icon-download"></span>
                {{ $t("global.下载") }}
              </a>
              <el-popover placement="bottom" trigger="hover" v-else>
                <p class="NoDownloading">
                  {{ $t("video.用户暂未开放该视频下载") }}
                </p>
                <a href="javascript:;" class="download1" slot="reference">
                  <span class="link-icon link-icon-download1"></span>
                  {{ $t("global.下载") }}
                </a>
              </el-popover>
              <a
                @click="openPhotos"
                v-if="videoItem.images && videoItem.images.length"
              >
                <span class="link-icon link-icon-photos"></span>
                {{ $t("video.图片相册") }}
                <span v-if="videoItem.images">{{
                  videoItem.images.length
                }}</span>
              </a>
              <a class="reportBut" @click="showReportV">{{
                $t("global.举报")
              }}</a>
              <div class="feedbackBox">
                <p class="reportBut">{{ $t("works.播放反馈") }}</p>
                <div class="feedback">
                  <div class="triangle"></div>
                  <p class="feedTitle">
                    {{ $t("works.反馈视频") }}：{{ videoItem.title }}
                  </p>
                  <div class="optionBox clearfix">
                    <div
                      class="text"
                      v-for="(item, i) in feedList"
                      :key="i"
                      @click="onOption(item)"
                    >
                      <span :class="{ active: item.status }"
                        ><i v-if="item.status"></i></span
                      >{{ item.name }}
                    </div>
                  </div>
                  <div class="describe">
                    <p class="desTitle">{{ $t("works.问题描述") }}：</p>
                    <el-input
                      type="textarea"
                      wrap="hard"
                      v-model="feedText"
                    ></el-input>
                  </div>
                  <div class="reBut" @click="repotFeed">
                    {{ $t("works.发送反馈") }}
                  </div>
                </div>
              </div>
              <div class="right">
                <a @click="DoLike" :class="{ color: videoItem.isLike }">
                  <span
                    v-if="videoItem.isLike"
                    class="link-icon link-icon-clap-active"
                  ></span>
                  <span v-else class="link-icon link-icon-clap"></span>
                  {{ videoItem.likeCount }}
                </a>
                <a @click="DoCollect" :class="{ color: isCollect }">
                  <span
                    v-if="isCollect"
                    class="link-icon link-icon-save-active"
                  ></span>
                  <span v-else class="link-icon link-icon-save"></span>
                  {{ collectCount }}
                </a>
                <div class="shareCodeContainerBox">
                  <div class="shareCodeContainer">
                    <div class="share bdsharebuttonbox">
                      <a
                        @click="commShare('weibo')"
                        class="bds_tsina top-bottom-icon icon-weibo"
                        :title="$t('global.分享到新浪微博')"
                      ></a>
                      <el-popover placement="bottom" trigger="hover">
                        <div id="qrcode1" ref="qrcode"></div>
                        <a
                          href="javascript:;"
                          class="bds_weixin top-bottom-icon icon-wechat"
                          :title="$t('global.分享到微信')"
                          slot="reference"
                        ></a>
                      </el-popover>
                      <a
                        @click="commShare('qq')"
                        class="bds_qzone top-bottom-icon icon-qq"
                        title="分享到QQ空间"
                      ></a>
                      <a
                        href="javascript:;"
                        class="bds_twi top-bottom-icon icon-twi"
                        @click="commShare('twi')"
                        title="分享到Twitter"
                      ></a>
                      <a
                        href="javascript:;"
                        class="bds_fbook top-bottom-icon icon-face"
                        @click="commShare('fbook')"
                        title="分享到Facebook"
                      ></a>
                    </div>
                    <div class="video" v-if="videoItem.qiniuData">
                      <p>{{ $t("video.嵌入视频") }}:</p>
                      <input
                        type="text"
                        ref="copyContent"
                        class="sharecode-content"
                        :value="`<iframe src=\'${origin}/video/${$query.id}\' frameborder='0' allowfullscreen='true' scrolling='no' style='max-width:100%;width:730px;height:410px;'></iframe>`"
                      />
                      <span class="sharecode-btn" @click="copy">{{
                        $t("video.复制代码")
                      }}</span>
                    </div>
                  </div>
                  <span class="top-bottom-icon icon-code"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="middle-left">
            <div class="middle-left-1">
              <div class="title">
                <i v-html="language === 'zh' ? videoItem.title : videoItem.enTitle || videoItem.title" v-if="!isHtml(language === 'zh' ? videoItem.title : videoItem.enTitle || videoItem.title)"></i>
                <i v-else>{{ language === 'zh' ? videoItem.title : videoItem.enTitle || videoItem.title }}</i>
                <span class="tip" v-if="videoItem.isOriginal == 1">{{
                  $t("global.原创")
                }}</span>
              </div>
              <div class="vedio-content">
                <span
                  class="category"
                  v-for="(item, index) in videoTags1"
                  :key="index"
                  @click="gotoCate(1,item)"
                >
                  <span class="value">{{
                    language === "zh" ? item.name : item.enName
                  }}</span>
                </span>
                <span class="line" v-if="videoTags2.length > 0"></span>
                <span
                  class="category"
                  v-for="item in videoTags2"
                  :key="item.id"
                  @click="gotoCate(11,item)"
                >
                  <span class="value">{{
                    language === "zh" ? item.name : item.enName
                  }}</span>
                </span>
                <span class="line" v-if="videoTags3.length > 0"></span>
                <span
                  class="category"
                  v-for="item in videoTags3"
                  :key="item.id"
                  @click="gotoCate(14,item)"
                >
                  <span class="value">{{
                    language === "zh" ? item.name : item.enName
                  }}</span>
                </span>
              </div>
              <div class="new_list">
                <router-link
                  to="/hotList/weeklist"
                  v-if="videoItem.clearWeekHeat"
                  target="_blank"
                >
                  <span class="value">
                    <img src="/static/video/editorpicks_tag_icon1.png" alt />
                    {{ $t("live.MANA榜单周榜 TOP")}}{{videoItem.topSize}}
                  </span>
                </router-link>
                <router-link
                  to="/hotList/monthlist"
                  target="_blank"
                  v-if="!videoItem.clearWeekHeat && videoItem.clearMonthHeat"
                >
                  <span class="value">
                    <img src="/static/video/editorpicks_tag_icon1.png" alt />
                    {{ $t("live.MANA榜单月榜 TOP")}}{{videoItem.topSize}}
                  </span>
                </router-link>
                <router-link
                  to="/hotList/alllist"
                  target="_blank"
                  v-if="
                    !videoItem.clearWeekHeat &&
                    !videoItem.clearMonthHeat &&
                    videoItem.clearHeat
                  "
                >
                  <span class="value">
                    <img src="/static/video/editorpicks_tag_icon1.png" alt />
                    {{ $t("live.MANA榜单总榜 TOP")}}{{videoItem.topSize}}
                  </span>
                </router-link>
              </div>
              <div class="vedio-name">
                <router-link
                  :to="'/peopleCenter/' + videoItem.userId"
                  target="_blank"
                >
                  <img
                    class="vedio-avatar"
                    :src="videoItem.avatar | imageUrl('', 80, 80)"
                  />
                  <span class="name">{{ videoItem.nickName }}</span>
                </router-link>
                <button
                  class="vedio-name-focus"
                  :class="{
                    'vedio-name-focusd': videoItem.isFollow,
                    'vedio-name-focusd-hover':
                      ishoveFolloe && videoItem.isFollow,
                  }"
                  v-on:click="Follow()"
                  @mouseenter="ishoveFolloe = true"
                  @mouseout="ishoveFolloe = false"
                >
                  {{
                    !videoItem.isFollow
                      ? $t("global.+关注")
                      : ishoveFolloe
                      ? $t("global.取消关注")
                      : $t("global.已关注")
                  }}
                </button>
                <span class="time">{{ videoItem.date }}</span>
                <span class="viewCount">
                  <img
                    class="img-view"
                    src="/static/video/view_icon@2x.png"
                    alt
                  />
                  {{ videoItem.viewCount }}
                </span>
              </div>
              <p
                class="video-other-title"
                v-if="
                  otherCreator.length > 1 ||
                  (otherCreator.length == 1 && otherCreator[0].role)
                "
              >
                {{ $t("global.创作者") }}
              </p>
              <div
                class="box"
                v-if="
                  otherCreator.length > 1 ||
                  (otherCreator.length == 1 && otherCreator[0].role)
                "
              >
                <router-link
                  class="vedio-name video-other"
                  v-for="(item, index) in otherCreator"
                  :key="index"
                  :to="'/peopleCenter/' + item.userId"
                  target="_blank"
                >
                  <div :class="['img', { userType2: item.userType === 2 && item.isCertification === 1 }]">
                    <img
                      class="vedio-avatar"
                      :src="item.avatar | imageUrl('', 100, 100)"
                    />
                  </div>
                  <div
                    class="vedio-name-center-top"
                    :class="[item.role ? 'has-role' : '']"
                  >
                    <p class="name">{{ item.nickName }}</p>
                    <p class="role" :title="item.role">{{ item.role }}</p>
                  </div>
                </router-link>
              </div>
              <div class="vedio-intro">
                <div class="new_tag" v-if="videoTags4 && videoTags4.length">
                  <img src="/static/video/tags_icon.png" alt />
                  <div
                    class="tag"
                    v-for="(item, index) in videoTags4"
                    :key="index"
                    @click="gotoCate(15,item)"
                    >{{
                      language === "zh" ? item.name : item.enName
                    }}</div
                  >
                </div>
                <div
                  class="intro-content"
                  v-html="toPageFilter_html(videoItem)"
                ></div>
                <div
                  class="software"
                  v-if="
                    videoTags5.length ||
                    videoTags6.length ||
                    videoTags7.length ||
                    videoTags8.length
                  "
                >
                  <p class="video_Tags" v-if="videoTags5.length">
                    {{ $t("video.使用软件") }}:
                    <router-link
                      type="span"
                      :to="{
                        path: '/Search',
                        query: {
                          content: language === 'zh' ? item.name : item.enName,
                        },
                      }"
                      v-for="(item, i) in videoTags5"
                      :key="i"
                      target="_blank"
                      >{{
                        language === "zh" ? item.name : item.enName
                      }}</router-link
                    >
                  </p>
                  <p class="video_Tags" v-if="videoTags6.length">
                    {{ $t("video.使用硬件") }}:
                    <router-link
                      type="span"
                      :to="{
                        path: '/Search',
                        query: {
                          content: language === 'zh' ? item.name : item.enName,
                        },
                      }"
                      v-for="(item, i) in videoTags6"
                      :key="i"
                      target="_blank"
                      >{{
                        language === "zh" ? item.name : item.enName
                      }}</router-link
                    >
                  </p>
                  <p class="video_Tags" v-if="videoTags7.length">
                    {{ $t("video.使用材料") }}:
                    <router-link
                      type="span"
                      :to="{
                        path: '/Search',
                        query: {
                          content: language === 'zh' ? item.name : item.enName,
                        },
                      }"
                      v-for="(item, i) in videoTags7"
                      :key="i"
                      target="_blank"
                      >{{
                        language === "zh" ? item.name : item.enName
                      }}</router-link
                    >
                  </p>
                  <p class="video_Tags" v-if="videoTags8.length">
                    {{ $t("video.技术手段及其他工具") }}:
                    <router-link
                      type="span"
                      :to="{
                        path: '/Search',
                        query: {
                          content: language === 'zh' ? item.name : item.enName,
                        },
                      }"
                      v-for="(item, i) in videoTags8"
                      :key="i"
                      target="_blank"
                      >{{
                        language === "zh" ? item.name : item.enName
                      }}</router-link
                    >
                  </p>
                </div>
              </div>
              <div
                class="photoAlbum"
                v-if="videoItem.images && videoItem.images.length"
              >
                <p>{{ $t("video.图片相册") }}</p>
                <ul class="clearfix">
                  <li
                    v-for="(item, i) in photosList"
                    :key="i"
                    @click="openPhoto(i)"
                  >
                    <img :src="item | imageUrl('', 350, 350)" alt />
                    <span v-if="videoItem.images.length > 7 && i == 6"
                      >+{{ videoItem.images.length - 7 }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="comment">
              <h4>{{ $t("global.评论") }}</h4>
              <div class="textarea" v-if="isLogin">
                <img
                  :src="
                    $store.state.peopleMessage.avatar | imageUrl('', 80, 80)
                  "
                  alt
                />
                <el-input
                  type="textarea"
                  :rows="2"
                  :placeholder="$t('global.发表您的评论…')"
                  v-model="commentContent"
                ></el-input>
                <button @click="SubmitComment()">
                  {{ $t("global.发表评论") }}
                </button>
              </div>
              <div class="no-login" v-else>
                <p>
                  {{ $t("global.请") }}
                  <span @click="Gotologin">{{ $t("global.登录") }}</span>
                  {{ $t("global.或") }}
                  <span @click="Gotoreg">{{ $t("global.注册") }}</span>
                  {{ $t("global.再发表评论") }}
                </p>
              </div>
              <div class="reply-wrap">
                <span v-if="commentListLength > 0">{{
                  $t("global.共x条评论", { count: videoItem.commentCount })
                }}</span>
                <ul class="reply-list" v-if="commentListLength > 0">
                  <li v-for="(item, index) in commentList" :key="index">
                    <video-card
                      @refresh="refresh"
                      :item="item"
                      :imageWidth="80"
                      @like="answerLike(item)"
                    />
                    <ul class="children" v-if="item.childrenPageList">
                      <li
                        v-for="(it, i) in parentId == item.id
                          ? childList
                          : item.childrenPageList.list"
                        :key="i"
                      >
                        <video-card
                          @refresh="refresh"
                          :item="it"
                          :imageWidth="60"
                          :isChild="true"
                          :parentId="item.id"
                          @like="answerLike(it)"
                        />
                      </li>
                      <li
                        @click="showMoreChild(item)"
                        class="show-more-child"
                        v-if="
                          item.childrenPageList.totalRecord >
                            item.childrenPageList.list.length && !isChilds
                        "
                      >
                        {{
                          $t("global.查看全部x条回复", {
                            count: item.childrenPageList.totalRecord,
                          })
                        }}
                      </li>
                    </ul>
                  </li>
                </ul>
                <div
                  class="reply-more"
                  v-if="commentListLength > commentList.length"
                >
                  <div @click="showMoreReply">
                    <span>{{ $t("global.查看更多") }}</span>
                  </div>
                </div>
                <div class="reply-empty" v-if="!commentListLength">
                  <img src="/static/v2/article/article_comment_empty.png" alt />
                  <span>{{ $t("global.还没有评论") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-container">
          <div class="top-right">
            <div
              class="top-right-top"
              v-if="
                !$query.lookId && relatedVedioList && relatedVedioList.length
              "
            >
              <div class="section-title">
                <span class="title-span">{{ $t("video.热门推荐") }}</span>
                <div class="autoPlay">
                  <el-switch
                    v-model="isAutoPlay"
                    active-color="#2026CC"
                    inactive-color="#E0E0E0"
                    :width="35"
                    @change="swichAuto"
                  ></el-switch>
                  {{ $t("video.自动播放") }}
                </div>
              </div>
              <div class="top-right-top-list">
                <div
                  class="item"
                  v-for="(item, index) in relatedVedioList"
                  :key="index"
                >
                  <router-link
                    type="div"
                    :to="'/video/detail?id=' + item.videoId"
                    class="item-left"
                    target="_blank"
                  >
                    <img :src="item.thumb | imageUrl('', 248, 140)" />
                  </router-link>
                  <div class="item-right">
                    <router-link
                      type="div"
                      :to="'/video/detail?id=' + item.videoId"
                      class="item-title"
                      target="_blank"
                      >{{ language === "zh" ? item.title : item.enTitle || item.title }}</router-link
                    >
                    <div class="item-middle">
                      <span
                        class="play-times"
                        v-for="(index, i) in item.categoryTagGroupInfoList"
                        :key="i"
                        >{{ index }}</span
                      >
                    </div>

                    <div class="item-bottom">
                      <router-link
                        :to="`/peopleCenter/${item.userId}`"
                        target="_blank"
                      >
                        <span class="item-name">{{ item.userNickName }}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="playAllBox" v-if="$query.lookId">
              <div class="infoBox">
                <div class="imgBox">
                  <img
                    class="lookIcon"
                    src="/static/collect/icon_playlist@2x.png"
                    alt=""
                  />{{ $t("collect.看单") }}
                </div>
                <router-link
                  :to="'/playlist/' + lookDetails.id"
                  target="_blank"
                  class="lookName"
                  >{{ lookDetails.name }}</router-link
                >
                <div class="info clearfix">
                  {{ $t("collect.创建者") }}：<span
                    class="name"
                    @click.stop.prevent="gotoPeople(lookDetails.userId)"
                    >{{ lookDetails.nickName }}</span
                  ><i>·</i
                  ><span>{{ lookIndex }}/{{ lookDetails.videoCount }}</span
                  ><span
                    class="collect"
                    :data-title="
                      lookDetails.isCollect
                        ? $t('collect.取消收藏此看单')
                        : $t('collect.收藏此看单')
                    "
                    @click="collectLook(lookDetails)"
                    ><img
                      v-if="lookDetails.isCollect"
                      class="lookIcon"
                      src="/static/collect/icon_playall_saved_btn@2x.png"
                      alt=""
                    /><img
                      v-else
                      class="lookIcon"
                      src="/static/collect/icon_playall_save_btn@2x.png"
                      alt=""
                    />{{ lookDetails.collectCount }}</span
                  >
                </div>
              </div>
              <div class="videoListBox">
                <div
                  class="videoList clearfix"
                  v-for="(item, i) in lookVideoList"
                  :key="i"
                  :class="{ lookActive: item.id == $query.id }"
                  @click="changeVideo(item.id)"
                >
                  <div class="number" v-if="item.id == $query.id">
                    <img src="/static/collect/icon_play_currently@2x.png" />
                  </div>
                  <div class="number" v-else>{{ i + 1 }}</div>
                  <div class="imgs">
                    <img :src="item.thumb | imageUrl('', 212, 120)" />
                  </div>
                  <div class="infoText">
                    <p class="videoTitle">{{ item.title }}</p>
                    <p class="videoTags">
                      <span
                        class="play-times"
                        v-for="(index, i) in item.categoryTagGroupInfoList"
                        :key="i"
                        >{{ index }}</span
                      >
                    </p>
                    <p class="videoname">
                      {{ item.userAccountDomain.nickName }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="middle-right">
            <div class="middle-right-1">
              <div
                class="location"
                v-if="locationList && locationList.length"
                @click="gotoLocation"
              >
                <img
                  class="locationImg"
                  :src="
                    JSON.parse(locationList[0].image)[0].key
                      | imageUrl('', 570, 140)
                  "
                  alt=""
                />
                <div class="advertisement" v-if="locationList[0].type == '2'">
                  {{ $t("video.广告") }}
                </div>
              </div>
            </div>
            <div class="middle-right-1">
              <div class="top-right-top" v-if="videoList && videoList.length">
                <div class="section-title">
                  <span class="title-span">{{ $t("video.TA的更多作品") }}</span>
                  <router-link
                    type="span"
                    :to="'/peopleCenter/' + videoItem.userId + '/video'"
                    class="viewAll"
                    target="_blank"
                    >{{ $t("global.查看全部") }}</router-link
                  >
                  <span class="right_icon"></span>
                </div>
                <div class="top-right-top-list">
                  <div
                    class="item"
                    v-for="(item, index) in videoList"
                    :key="index"
                  >
                    <router-link
                      type="div"
                      :to="'/video/detail?id=' + item.videoId"
                      class="item-left"
                    >
                      <img :src="item.thumb | imageUrl('', 248, 140)" />
                    </router-link>
                    <div class="item-right">
                      <router-link
                        type="div"
                        :to="'/video/detail?id=' + item.videoId"
                        class="item-title"
                        target="_blank"
                        >{{ item.title }}</router-link
                      >
                      <div class="item-middle">
                        <span
                          class="play-times"
                          v-for="(index, i) in item.professionList"
                          :key="i"
                          >{{
                            language === "zh" ? index.title : index.titleEn
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="middle-right-1">
              <img
                class="app_promo"
                :src="
                  language === 'zh'
                    ? '/static/video/Sidebar_app_promo_CN@2x.png'
                    : '/static/video/Sidebar_app_promo_EN@2x.png'
                "
                alt
              />
            </div>
            <div
              class="middle-right-1"
              v-if="hotEventsList && hotEventsList.length"
            >
              <div class="top-right-top">
                <div class="section-title">
                  <span class="title-span">{{ $t("global.热门活动") }}</span>
                  <router-link type="span" to="/activity" class="viewAll">{{
                    $t("global.查看全部")
                  }}</router-link>
                  <span class="right_icon"></span>
                </div>
                <div class="top-right-top-list">
                  <router-link
                    type="div"
                    :to="'/activityDetail/' + item.id"
                    v-for="(item, i) in hotEventsList"
                    :key="i"
                    class="hot"
                  >
                    <div class="img">
                      <img :src="item.thumb | imageUrl('', 190, 252)" alt />
                      <p class="now" v-if="item.holdStartTime < Date.now()">
                        {{ $t("global.进行中") }}
                      </p>
                      <p class="soon" v-if="item.holdStartTime > Date.now()">
                        {{ $t("video.即将开始") }}
                      </p>
                    </div>
                    <div class="title">
                      <p class="title1">{{ item.title }}</p>
                      <p class="title2">
                        {{ dateFormatter(new Date(item.holdStartTime)) }} -
                        {{ dateFormatter(new Date(item.holdEndTime)) }}
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- <div class="middle-right-2" v-if="game.length > 0">
              <div class="middle-right-title">{{$t('global.专业比赛')}}</div>
              <div class="middle-right-subtitle">{{$t('global.本作品已参赛')}}</div>
              <img class="middle-right-img" :src="game.thumb | imageUrl()" />
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="isSecretBox" v-if="type == 1">
      <img
        class="secretImg"
        src="/static/collect/img_playlist_deleted@2x.png"
        alt=""
      />
      <p class="secretTitle">{{ $t("collect.此看单已被删除") }}</p>
      <router-link to="/" class="secretBut">{{
        $t("collect.返回首页")
      }}</router-link>
    </div>
    <div class="isSecretBox" v-if="type == 2">
      <img
        class="secretImg"
        src="/static/collect/img_playlist_locked@2x.png"
        alt=""
      />
      <p class="secretTitle">{{ $t("collect.此看单已被设置为私密") }}</p>
      <router-link to="/" class="secretBut">{{
        $t("collect.返回首页")
      }}</router-link>
    </div>
    <div class="isSecretBox" v-if="type == 4">
      <img
        class="secretImg"
        src="/static/newSearch/video_empty@2x.png"
        alt=""
      />
      <p class="secretTitle">{{ $t("collect.此看单暂无内容") }}</p>
      <router-link to="/" class="secretBut">{{
        $t("collect.返回首页")
      }}</router-link>
    </div>
    <div class="isSecretBox" v-if="isVideoOpen">
      <img
        class="secretImg"
        src="https://image.manamana.net/1615974806000_QgHxoTXG"
        alt=""
      />
      <p class="secretTitle">{{ $t("people.此视频暂不公开") }}</p>
      <router-link to="/" class="secretBut">{{
        $t("collect.返回首页")
      }}</router-link>
    </div>
    <join-dialog
      :visible.sync="groupDialogVisible"
      :videoItem="videoItem"
      :groupSelectedType.sync="groupSelectedType"
      @hiddendialog="hiddenDialog"
    ></join-dialog>
    <subjectDialog
      v-if="showSubject"
      :videoId="$route.query.id"
      @hiddendialog="hiddenDialog"
    />
    <el-dialog :visible.sync="reportVisible" width="22%">
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item :label="`${$t('global.请填写举报理由')}：`">
          <el-checkbox-group v-model="form.reason">
            <el-checkbox
              :label="$t('global.涉及黄赌毒和暴力')"
              name="reason"
            ></el-checkbox>
            <el-checkbox :label="$t('global.政治')" name="reason"></el-checkbox>
            <el-checkbox
              :label="$t('global.版权问题')"
              name="reason"
            ></el-checkbox>
            <el-checkbox :label="$t('global.抄袭')" name="reason"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-input
            type="textarea"
            wrap="hard"
            v-model="form.content"
            :placeholder="$t('global.请输入举报内容，我们将尽快处理。')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{
            $t("global.提交")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <p class="message">
            {{ $t("global.也可发邮件给我们") }}：info@manamana.net
          </p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div class="photoBox" v-if="isPhotoBox">
      <div class="pic-container">
        <template v-if="videoItemImagesLength > 0">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="home-banner-swiper"
          >
            <!-- slides -->
            <swiper-slide
              v-for="(item, index) of videoItem.images"
              :key="index"
              class="swiper-no-swiping"
              height="100%"
            >
              <span class="videm-img-wrap">
                <img class="videoImg" :src="item | imageUrl()" alt />
              </span>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-prev el-icon-arrow-left"
            @click="prePage"
            v-if="videoItemImagesLength != 1"
          ></div>
          <div
            class="swiper-button-next el-icon-arrow-right"
            @click="nextPage"
            v-if="videoItemImagesLength != 1"
          ></div>
          <div class="close" @click="isPhotoBox = false">
            <img src="/static/video/photo_close_btn.png" alt />
          </div>
          <div class="page">{{ pageIndex }}/{{ videoItem.images.length }}</div>
        </template>
        <img
          class="noimage"
          v-if="videoItemImagesLength == 0"
          :src="videoItem.thumb | imageUrl('', '', 620)"
        />
      </div>
    </div>
    <div class="createPop" v-if="cleateLookPop">
      <div class="popBox">
        <p class="popTitle">
          <span class="title1">{{ $t("collect.收藏到看单") }}</span
          ><span class="title2" @click="gotoSeeLook"
            ><img
              class="infoIcon"
              src="/static/collect/icon_playlist_info@2x.png"
              alt=""
            />{{ $t("collect.什么是看单") }}</span
          ><img
            class="close"
            @click="cleateLookPop = false"
            src="/static/close_btn@2x.png"
            alt=""
          />
        </p>
        <div class="from1">
          <div class="nameBox" v-for="(item, i) in createList" :key="i">
            <div class="selectBox" @click="selectLook(item)">
              <img
                v-if="item.isCollect"
                src="/static/uploadvideo/icon_upload_multi_selected@2x.png"
                alt=""
              /><span v-else class="textBox"></span>

              <span class="textTi">{{ item.name }}</span>
            </div>
            <img
              v-if="item.isSecret == 1"
              class="privateIcon"
              src="/static/collect/icon_playlist_locked@2x.png"
              alt=""
            />
          </div>
        </div>
        <div class="buttom1 clearfix">
          <span
            class="create"
            @click="
              (createPop = true),
                (isSecret = 0),
                (nametext = ''),
                (newCollectId = null)
            "
            ><img
              src="/static/collect/icon_add_playlist_hover@2x.png"
              alt=""
            />{{ $t("collect.新建看单") }}</span
          >
          <div class="butBox">
            <span class="cel" @click="cleateLookPop = false">{{
              $t("collect.取消")
            }}</span
            ><span
              class="cir"
              :class="{ colorCir: isLook }"
              @click="saveLook"
              >{{ $t("collect.确定") }}</span
            >
          </div>
        </div>
      </div>
      <div class="popBox" v-if="createPop">
        <p class="titleText">
          {{ $t("collect.新建看单")
          }}<img
            @click="createPop = false"
            class="close"
            src="/static/close_btn@2x.png"
            alt=""
          />
        </p>
        <div class="from">
          <p class="name"><i>*</i>{{ $t("collect.看单名称") }}</p>
          <div class="text">
            <input
              v-model="nametext"
              type="text"
              :placeholder="$t('collect.请输入名称')"
            /><span class="numLen">{{ nametext.length }}/40</span>
          </div>
          <p class="name"><i>*</i>{{ $t("collect.是否公开") }}</p>
          <div class="select clearfix">
            <span class="left" @click="isSecret = 0"
              ><i class="circular" :class="{ cirColor: isSecret == 0 }"
                ><i class="isSele" v-if="isSecret == 0"></i></i
              >{{ $t("collect.公开") }}</span
            >
            <span class="right" @click="isSecret = 1"
              ><i class="circular" :class="{ cirColor: isSecret == 1 }"
                ><i class="isSele" v-if="isSecret == 1"></i></i
              >{{ $t("collect.私密") }}</span
            >
          </div>
        </div>
        <div class="buttom">
          <span class="cel" @click="createPop = false">{{
            $t("collect.取消")
          }}</span
          ><span class="cir" @click="saveLook1">{{ $t("collect.确定") }}</span>
        </div>
      </div>
    </div>
    <service />
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import service from "../components/service.vue";
import joinDialog from "../components/JoinDialog.vue";
import subjectDialog from "../components/subjectDialog.vue";
import manaPlayer from "../components/video/ManaPlayer";
import comm from "@/assets/comm.js";
import { imageUrl } from "@/util/filters.js";
import pages from "../components/pages.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import tools from "@/util/tools";
import Share from "@/components/v2/Share";
import VideoCard from "@/components/v2/VideoCard";
import swiper_member from "@/components/list/swiper_member.vue";
import QRCode from "qrcodejs2";

export default {
  metaInfo() {
    return this.metaInfoData;
  },

  components: {
    MainLayout,
    service,
    joinDialog,
    manaPlayer,
    swiper,
    swiperSlide,
    pages,
    Share,
    VideoCard,
    swiper_member,
    QRCode,
    subjectDialog
  },
  data() {
    return {
      locationList: [],
      videoTags1: [],
      videoTags2: [],
      videoTags3: [],
      videoTags4: [],
      videoTags5: [],
      videoTags6: [],
      videoTags7: [],
      videoTags8: [],
      parentId: null,
      qrcode: null,
      ishoveFolloe: false,
      isChilds: false,
      childList: [],
      commentListLength: null,
      isMin: false,
      config: {},
      origin: "",
      metaInfoData: {},
      title: "",
      detail_ViewCount: 0,
      otherCreator: [],
      autoplaynext: true,
      isLogin: true,
      switchChoose: true,
      commentContent: "",
      replyContent: "",
      showReplyId: 0,
      isShowShareCode: false,
      videoItem: {},
      videoList: [],
      hotEventsList: [],
      videoItemImagesLength: 0,
      commentList: [],
      reportVisible: false,
      reportId: "",
      commentTotalPage: 1,
      game: [],
      reportType: 1,
      relatedVedioList: [],
      lookList: [],
      recommendVedioList: [],
      groupDialogVisible: false,
      groupSelectedType: 1,
      isPhotoBox: false,
      photosList: [],
      pageIndex: 1,
      isAutoPlay: false,
      isVideoPlay: false,
      swiperOption: {
        autoplay: false,
        noSwiping: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      form: {
        reason: [],
        content: ""
      },
      videoPagerParam: {
        pageSize: 6,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },

      pagerParam: {
        pageSize: 5,
        pageIndex: 1,
        hasNextPage: true
      },

      playerOptions: {
        muted: true,
        autoplay: true,
        preload: "auto",
        language: "zh",
        sources: [
          {
            type: "video/mp4",
            src: ""
          }
        ],
        // poster: "/static/default.png",
        notSupportedMessage: `${this.$t("global.视频加载中")}，${this.$t(
          "global.请稍后"
        )}...`
      },
      cleateLookPop: false,
      createPop: false,
      createList: [],
      favoritesIds: [],
      nametext: "",
      isSecret: 0,
      isCollect: false,
      collectCount: 0,
      lookDetails: {},
      lookIndex: 1,
      lookVideoList: [],
      type: 3,
      isLook: true,
      createIds: [],
      feedList: [
        { name: this.$t("works.播放卡顿"), status: false, index: 1 },
        { name: this.$t("works.进度条拖动失败"), status: false, index: 2 },
        {
          name: this.$t("works.播放时一直出现加载动画"),
          status: false,
          index: 3
        },
        { name: this.$t("works.黑屏"), status: false, index: 4 },
        { name: this.$t("works.其它"), status: false, index: 5 }
      ],
      feedText: null,
      showSubject: false,
      newCollectId: null,
      isVideoOpen: false
    };
  },

  methods: {
    gotoCate(index, item) {
      // let routeData = null;
      // if (item.status == 0) {
      //     routeData = this.$router.resolve({
      //     path: "/Search",
      //     query: { content: this.language === 'zh' ? item.name : item.enName },
      //   });
      // }
      // if (item.status == 1) {
      //     routeData = this.$router.resolve({
      //     path: "/explorevideo",
      //     query: { topGroupId: index, groupId: item.id },
      //   });
      // }
      let routeData = this.$router.resolve({
        path: "/Search",
        query: { content: this.language === "zh" ? item.name : item.enName }
      });
      window.open(routeData.href, "_blank");
    },
    getLocation() {
      this.$http.get("/api/operations/list/2").then(res => {
        if (res.code === "OK") {
          this.locationList = res.data;
          if (this.locationList.length) {
            this.locationShow(this.locationList[0]);
          }
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id
      };
      this.$http.post("/api/operations/click", params).then(res => {
        //运营位点击
      });
    },
    locationShow(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id
      };
      this.$http.post("/api/operations/show", params).then(res => {
        //运营位展示
      });
    },
    gotoLocation() {
      this.locationClick(this.locationList[0]);
      this.openLocatione(this.locationList[0]);
    },
    //查看全部x条评论
    showMoreChild(item) {
      this.$http
        .get("/api/mobile/comment/childrenCommentList", {
          params: {
            parentId: item.id,
            pageIndex: 1,
            pageSize: item.childrenPageList.totalRecord,
            type: 1
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.isChilds = true;
            this.childList = res.data.list;
            this.parentId = item.id;
          } else {
            this.$message(res.message);
          }
        });
    },
    // 评论
    getComment(index) {
      if (index) {
        this.pagerParam.pageIndex = 1;
        this.pagerParam.pageSize = index;
      }
      this.$http
        .get("/api/mobile/video/commentList", {
          params: {
            videoId: this.$route.query.id,
            pageIndex: this.pagerParam.pageIndex,
            pageSize: this.pagerParam.pageSize
          }
        })
        .then(res => {
          if (res.code == "OK") {
            this.commentList.push(...res.data.list);
            this.commentListLength = res.data.totalRecord;
            this.pagerParam.hasNextPage = res.data.hasNextPage;
          } else {
            this.pagerParam.pageIndex--;
          }
        });
    },
    refresh() {
      this.commentList = [];
      this.getComment(this.pagerParam.pageIndex * 5);
    },
    showMoreReply() {
      this.pagerParam.pageIndex++;
      this.getComment();
    },
    swichAuto(val) {
      this.isAutoPlay = val;
      if (val) {
        localStorage.setItem("isAutoPlay", 1);
      } else {
        localStorage.setItem("isAutoPlay", 2);
      }
    },
    changeVideo(id) {
      this.$router.push(
        "/video/detail?id=" + id + "&lookId=" + this.$query.lookId
      );
    },
    closePlayer(val) {
      this.isVideoPlay = val;
      window.removeEventListener("scroll", this.showIcon, false);
    },
    dateFormatter: tools.dateFormatter,
    prePage() {
      if (this.pageIndex > 1) {
        this.pageIndex--;
      }
      return;
    },
    nextPage() {
      if (this.pageIndex < this.videoItem.images.length) {
        this.pageIndex++;
      }
      return;
    },
    openPhoto(i) {
      this.isPhotoBox = true;
      this.pageIndex = i + 1;
      this.$nextTick(() => {
        if (this.videoItem.images.length > 7 && i == 7) {
          this.$refs.mySwiper.swiper.slideTo(0);
        }
        this.$refs.mySwiper.swiper.slideTo(i);
      });
    },
    openPhotos() {
      this.isPhotoBox = true;
      this.pageIndex = 1;
    },
    toPageFilter_html(item) {
      let value = "";
      if (item.editStatus == 1) {
        value =
          this.language === "zh"
            ? item.introductionText
            : item.enIntroductionText || item.introductionText;
      } else {
        value =
          this.language === "zh"
            ? item.introduction
            : item.enIntroduction || item.introduction;
      }
      if (value == null) {
        return "";
      }
      // value = value.replace(/(\r\n|\n|\r)/gm, '<br />');
      if (item.editStatus == 1) {
        let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
        value = value.replace(reg, "<a href='$1$2' target='_blank'>$1$2</a>");
        let arr = value.split("\n");
        let str = "";
        for (let i = 0; i < arr.length; i++) {
          const el = arr[i];
          // str += "&nbsp;&nbsp;&nbsp;&nbsp;"+el +"<br/>"
          str += el + "<br/>";
        }
        return str;
      } else {
        return value;
      }
    },
    goToUserPage(userId) {
      this.$router.push("/peopleCenter/" + userId);
    },
    Gotologin() {
      this.$router.push(
        "/login?redirecturl=" +
          window.location.pathname +
          window.location.search
      );
    },
    Gotoreg() {
      this.$router.push(
        "/reg?redirecturl=" + window.location.pathname + window.location.search
      );
    },
    copy() {
      this.$refs.copyContent.select();
      document.execCommand("Copy");
      this.$message.success(this.$t("global.已复制"));
    },
    gotoSeeLook() {
      let routeData = this.$router.resolve({ path: "/treaty/3349" });
      window.open(routeData.href, "_blank");
    },
    showReply(id) {
      this.replyContent = "";
      if (this.showReplyId == id) {
        this.showReplyId = 0;
      } else {
        this.showReplyId = id;
      }
    },
    showReportV() {
      this.reportVisible = true;
      this.reportType = 1;
      this.reportId = this.$query.id;
    },
    showReportC(id) {
      this.reportVisible = true;
      this.reportType = 2;
      this.reportId = id;
    },
    onOption(item) {
      item.status = !item.status;
    },
    repotFeed() {
      let reason = [];
      for (let i = 0; i < this.feedList.length; i++) {
        if (this.feedList[i].status) {
          reason.push(this.feedList[i].name);
        }
      }
      this.$http
        .post(
          "/api/u/report/?reason=" +
            reason.toString() +
            "&content=" +
            this.feedText +
            "&domainId=" +
            this.$route.query.id +
            "&type=8"
        )
        .then(res => {
          if (res.code === "OK") {
            this.$message.success(this.$t("global.提交成功"));
          }
        });
    },
    switchV() {
      this.switchChoose = true;
    },
    switchP() {
      this.switchChoose = false;
    },
    onSubmit() {
      var $this = this;
      this.$http
        .post(
          "/api/u/report/?reason=" +
            this.form.reason.toString() +
            "&content=" +
            this.form.content +
            "&domainId=" +
            this.reportId +
            "&type=" +
            this.reportType
        )
        .then(function(response) {
          if (response.code === "OK") {
            $this.$message.success($this.$t("global.提交成功"));
            setTimeout(() => {
              $this.reportVisible = false;
            }, 2000);
          }
        });
    },
    SubmitComment() {
      var $this = this;
      if (!this.commentContent.replace(/[\r\n\s]/g, "")) {
        $this.$message.error(this.$t("global.回复内容不能为空"));
        return false;
      }
      if (this.commentContent.length > 5000) {
        $this.$message.error(
          `${this.$t("global.回复内容不能超过")}5000${this.$t("global.字")}`
        );
        return false;
      }
      this.$http
        .post("/api/u/comment/createComment", {
          domainId: this.$query.id,
          type: 1,
          content: this.commentContent
        })
        .then(function(response) {
          if (response) {
            $this.commentContent = "";
            $this.$message(response.message);
            $this.commentList = [];
            $this.pagerParam.pageIndex = 1;
            $this.getComment();
          }
        });
    },
    SubmitReplyComment() {
      var $this = this;
      if (!this.replyContent.replace(/[\r\n\s]/g, "")) {
        $this.$message.error(this.$t("global.回复内容不能为空"));
        return false;
      }
      if (this.replyContent.length > 5000) {
        $this.$message.error(
          `${this.$t("global.回复内容不能超过")}5000${this.$t("global.字")}`
        );
        return false;
      }
      this.$http
        .post("/api/u/comment/createReply", {
          commentId: this.showReplyId,
          content: this.replyContent
        })
        .then(function(response) {
          if (response) {
            $this.replyContent = "";
            $this.$message(response.message);
          }
        });
    },
    cancelReply() {
      this.replyContent = "";
      this.showReplyId = 0;
    },
    Follow() {
      var $this = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      if (this.videoItem.isFollow) {
        this.$http
          .post("/api/u/relation/unfollow/" + this.videoItem.userId)
          .then(function(response) {
            if (response) {
              $this.videoItem.isFollow = false;
              $this.$message(response.message);
            }
          });
      } else {
        this.$http
          .post("/api/u/relation/follow/" + this.videoItem.userId)
          .then(function(response) {
            if (response.code === "OK") {
              $this.videoItem.isFollow = true;
              $this.$message.success(response.message);
            }
          });
      }
    },
    DoLike() {
      let $this = this;
      if ($this.videoItem.isLike) {
        this.$http
          .post("/api/u/relation/cancel/like/" + this.$query.id)
          .then(function(response) {
            if (response) {
              // $this.getData();
              if ($this.videoItem.likeCount > 0) {
                $this.videoItem.likeCount--;
              }
              $this.videoItem.isLike = false;
              $this.$message($this.$t("global.取消点赞成功"));
            }
          });
      } else {
        this.$http
          .post("/api/u/relation/comment/" + this.$query.id, {
            domainType: 1,
            type: 3
          })
          .then(function(response) {
            if (response.code === "OK") {
              // $this.getData();
              $this.videoItem.likeCount++;
              $this.videoItem.isLike = true;
              $this.$message.success($this.$t("global.点赞成功"));
            }
          });
      }
    },
    getCollectCount() {
      this.$http.get("/api/fav/count?videoId=" + this.$query.id).then(res => {
        if (res.code === "OK") {
          this.isCollect = res.data.isCollect;
          this.collectCount = res.data.collectCount;
        }
      });
    },
    selectLook(item) {
      item.isCollect = !item.isCollect;
      let index = this.favoritesIds.indexOf(item.id);
      if (index == -1) {
        this.favoritesIds.push(item.id);
      } else {
        this.favoritesIds.splice(index, 1);
      }
    },
    saveLook() {
      if (this.isLook) {
        return;
      }
      let params = {
        favoritesIds: this.favoritesIds,
        videoId: this.$query.id
      };
      this.$http
        .post("/api/u/fav/collectVideo", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code === "OK") {
            if (this.favoritesIds.length) {
              this.$message({
                message: this.$t("collect.更新收藏成功！"),
                type: "success",
                offset: 220
              });
            } else {
              this.$message({
                message: this.$t("collect.取消收藏成功！"),
                type: "success",
                offset: 220
              });
            }
            this.cleateLookPop = false;
            this.getCollectCount();
          }
        });
    },
    saveLook1() {
      if (!this.nametext.replace(/[\r\n\s]/g, "")) {
        this.$message({
          message: this.$t("collect.名称不能为空！"),
          type: "warning",
          offset: 220
        });
        return;
      }
      let form = {
        name: this.nametext,
        isSecret: this.isSecret
      };
      this.$http
        .post("/api/u/fav/", form, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.code === "OK") {
            this.createPop = false;
            this.$message({
              message: res.message,
              offset: 420
            });
            this.newCollectId = res.data.id;
            this.$http
              .get("/api/fav/collectVideo/" + this.$query.id)
              .then(res => {
                if (res.code === "OK") {
                  this.createList = res.data;
                  this.favoritesIds = [];
                  this.createIds = [];
                  if (this.createList.length) {
                    for (let i = 0; i < this.createList.length; i++) {
                      if (this.createList[i].isCollect) {
                        this.favoritesIds.push(this.createList[i].id);
                        this.createIds.push(this.createList[i].id);
                      }
                      if (this.createList[i].id == this.newCollectId) {
                        this.selectLook(this.createList[i]);
                      }
                    }
                  }
                }
              });
          }
        });
    },
    DoCollect() {
      this.favoritesIds = [];
      this.createIds = [];
      this.$http.get("/api/fav/collectVideo/" + this.$query.id).then(res => {
        if (res.code === "OK") {
          this.createList = this.$pureData(res.data);
          this.cleateLookPop = true;
          if (this.createList.length) {
            for (let i = 0; i < this.createList.length; i++) {
              if (this.createList[i].isCollect) {
                this.favoritesIds.push(this.createList[i].id);
                this.createIds.push(this.createList[i].id);
              }
            }
          }
        }
      });
    },
    addToSubject() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      this.groupSelectedType = 1;
      this.groupDialogVisible = true;
    },
    hiddenDialog() {
      this.groupDialogVisible = false;
    },
    recommendToSubject() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      this.groupSelectedType = 2;
      this.groupDialogVisible = true;
    },
    report() {},
    playEnd() {
      if (
        this.autoplaynext &&
        this.relatedVedioList &&
        this.relatedVedioList.length > 0
      ) {
        this.$route.push(
          "/video/detail?id=" + this.relatedVedioList[0].videoId
        );
      }
    },
    commShare(str) {
      const data = this.$pureData(this.videoItem);
      const _this = this;
      if (data && data.title) {
      } else {
        return false;
      }
      var param = {
        title: data.title + "| MANA",
        url: window.location.href,
        pic: imageUrl(data.thumb)
      };
      if (str === "weibo") {
        comm.shareToweibo(param);
      } else if (str === "qq") {
        comm.shareToQq(param);
      } else if (str === "twi") {
        window.open(
          `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(
            param.url
          )}&url=${encodeURIComponent(param.url)}&text=${encodeURIComponent(
            param.title
          )}&pic=${param.pic}&searchPic=true`
        );
      } else if (str === "fbook") {
        window.open(
          `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
            param.url
          )}&title=${encodeURIComponent(param.title)}&pic=${
            param.pic
          }&searchPic=true`
        );
      }
    },
    //TA的作品
    getVideoList() {
      this.videoList = [];
      const url = `/api/mobile/u/getVideoList`;
      const params = {
        userId: this.videoItem.userId,
        order: 0,
        pageIndex: 1,
        pageSize: 5
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.videoList = res.data.list.filter(
            item => item.videoId != this.$query.id
          );
          if (this.videoList.length > 4) {
            this.videoList = this.videoList.slice(0, 4);
          }
        }
      });
    },
    //热门活动
    getVideoHotEvents() {
      const url = `/api/activity/indexList`;
      const params = {
        orderBy: 0,
        pageIndex: 1,
        pageSize: 12
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.hotEventsList = res.data.list.filter(item => {
            return item.holdEndTime > Date.now();
          });
          if (this.hotEventsList.length > 3) {
            this.hotEventsList = this.hotEventsList.slice(0, 3);
          }
        }
      });
    },
    getData() {
      var $this = this;
      this.$http
        .get("/api/video/detail?videoId=" + this.$query.id)
        .then(response => {
          if (response.data) {
            if (response.data == "1") {
              $this.isVideoOpen = true;
              let title = this.$t("people.此视频暂不公开");
              $this.metaInfoData = {
                title: `${title} - MANA ${this.$t(
                  "global.全球新媒体艺术平台"
                )} ${this.$t("global.艺术")}/${this.$t(
                  "global.设计"
                )}/${this.$t("global.科技")}/${this.$t("global.跨界创新")}`,
                meta: [
                  {
                    name: "keyWords",
                    content: `${title}${this.$t(
                      "global.交互设计"
                    )},MAPPING,${this.$t("global.装置空间")},${this.$t(
                      "global.设计"
                    )},${this.$t("global.公共艺术")},（${this.$t(
                      "global.专业标签词"
                    )}）,Max/Msp,Ableton,Arduino（${this.$t(
                      "global.制作软件词"
                    )})`
                  },
                  { name: "description", content: title }
                ],
                link: [
                  {
                    // set link
                    rel: title,
                    href: `https://www.manamana.net/activity/${
                      this.$query.id
                    }/detail`
                  }
                ]
              };
            } else {
              let title = response.data.nickName + ":" + response.data.title;
              let videoId = response.data.videoId;
              let image = "https://image.manamana.net/" + response.data.thumb
              let video = "https://video.manamana.net/" + JSON.parse(response.data.qiniuData).resource.s720
              // this.commentListLength = response.data.commentCount;
              $this.metaInfoData = {
                title: `${title} - MANA ${this.$t(
                  "global.全球新媒体艺术平台"
                )} ${this.$t("global.艺术")}/${this.$t(
                  "global.设计"
                )}/${this.$t("global.科技")}/${this.$t("global.跨界创新")}`,
                meta: [
                  {
                    name: "keyWords",
                    content: `${title}${this.$t(
                      "global.交互设计"
                    )},MAPPING,${this.$t("global.装置空间")},${this.$t(
                      "global.设计"
                    )},${this.$t("global.公共艺术")},（${this.$t(
                      "global.专业标签词"
                    )}）,Max/Msp,Ableton,Arduino（${this.$t(
                      "global.制作软件词"
                    )})`
                  },
                  { name: "description", content: title },
                  { name: "og:video", content: video },
                  { name: "og:site_name ", content: "MANA全球新媒体艺术平台" },
                  { name: "og:image", content: image }
                ],
                link: [
                  {
                    // set link
                    rel: title,
                    href: `https://www.manamana.net/activity/${videoId}/detail`
                  }
                ]
              };
              //标签
              let tags = response.data.videoTagGroupDetailResponses;
              if (tags && tags.length) {
                for (let i = 0; i < tags.length; i++) {
                  if (tags[i].groupId == "1") {
                    this.videoTags1 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "11") {
                    this.videoTags2 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "14") {
                    this.videoTags3 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "15") {
                    this.videoTags4 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "16") {
                    this.videoTags5 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "17") {
                    this.videoTags6 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "18") {
                    this.videoTags7 = tags[i].videoTagDomainList;
                  }
                  if (tags[i].groupId == "19") {
                    this.videoTags8 = tags[i].videoTagDomainList;
                  }
                }
              }
              $this.detail_ViewCount = response.data.viewCount;
              $this.otherCreator = response.data.creatorList;
              $this.videoItem = $this.$pureData(response.data);
              if ($this.videoItem) {
                $this.videoItem.equipmentList = $this.videoItem.equipment.split(
                  ","
                );
              } else {
                $this.videoItem.equipmentList = [];
              }

              if ($this.videoItem.images.length > 7) {
                $this.photosList = $this.videoItem.images.slice(0, 7);
              } else {
                $this.photosList = $this.videoItem.images;
              }
              $this.getVideoList();
              $this.videoItem.qiniuData = JSON.parse(response.data.qiniuData);
              if (response.data.qiniuMarkData) {
                $this.videoItem.qiniuMarkData = JSON.parse(
                  response.data.qiniuMarkData
                );
              }
              const qiniuData = $this.$pureData($this.videoItem.qiniuData);
              if (qiniuData.resource) {
                Object.keys(qiniuData.resource).forEach(key => {
                  if (
                    qiniuData.resource[key].indexOf("http://") === -1 &&
                    qiniuData.resource[key].indexOf("https://") === -1
                  ) {
                    qiniuData.resource[key] =
                      "https://video.manamana.net/" + qiniuData.resource[key];
                  }
                });
              } else {
                if (
                  response.data.url.indexOf("http://") === -1 &&
                  response.data.url.indexOf("https://") === -1
                ) {
                  qiniuData.resource = {
                    s1080: "https://video.manamana.net/" + response.data.url
                  };
                } else {
                  qiniuData.resource = {
                    s1080: response.data.url
                  };
                }
              }
              $this.playerOptions.videoList = qiniuData.resource;
              let img = response.data.thumb,
                img_o = img;
              img_o = imageUrl(img, null, 1280, 720);
              $this.playerOptions.poster = img_o;
              // $this.playerOptions.autoplay = $this.isAutoPlay;
              // if (this.$query.lookId) {
              //   $this.playerOptions.autoplay = true;
              // } else {
              //   if (localStorage.getItem("isAutoPlay") != null) {
              //     if (localStorage.getItem("isAutoPlay") == 1) {
              //       $this.playerOptions.autoplay = true;
              //     }
              //     if (localStorage.getItem("isAutoPlay") == 2) {
              //       $this.playerOptions.autoplay = false;
              //     }
              //   }
              // }
              $this.playerOptions.sources = [
                {
                  type: "video/mp4",
                  src: qiniuData.resource["s1080"]
                }
              ];
              document.title = $this.videoItem.title + " | MANA";
              $this.videoItemImagesLength = $this.videoItem.images.length;
              $this.getComment();
              $this.$nextTick(() => {
                window._bd_share_config = {
                  common: {
                    bdSnsKey: {},
                    bdText: $this.videoItem.title,
                    bdDesc: $this.videoItem.title,
                    bdMini: "2",
                    bdMiniList: false,
                    bdPic: $this.videoItem.images.join("||"),
                    bdStyle: "1",
                    bdSize: "16"
                  },
                  share: {}
                };
                const s = document.createElement("script");
                s.type = "text/javascript";
                //s.src = "/static/share/baidushare.js";
                s.src = "/static/api/js/share.js";
                document.body.appendChild(s);
              });
              $this.config = {
                share_url: window.location.href,
                title: $this.videoItem.title,
                desc: "MANA 全球新媒体艺术平台",
                pics: $this.videoItem.images.join("||")
              };
              $this.$nextTick(() => {
                $this.$refs.qrcode.innerHTML = "";
                $this.makeQrcode();
              });
            }
          }
        });
      // this.$http
      //   .get("/api/video/gameList?videoId=" + this.$query.id)
      //   .then(function (response) {
      //     if (response.data && response.data.length > 0) {
      //       $this.game = response.data[0];
      //     } else {
      //       $this.game = [];
      //     }
      //   });
    },
    getRecommend() {
      let $this = this;
      if (!this.$query.lookId) {
        this.$http
          .get(
            "/api/mobile/2.0/recommend/hotVideoList?orderByType=1&pageIndex=1&pageSize=6"
          )
          .then(function(response) {
            if (response.data) {
              let idsList = [];
              for (let i = 0; i < response.data.ids.length; i++) {
                if (response.data.ids[i] !== $this.$query.id) {
                  idsList.push(response.data.ids[i]);
                }
              }
              var ids = $this.getRandomArrayElements(idsList, 5);
              $this.$http
                .get(
                  "/api/mobile/2.0/recommend/hotVideoPage?ids=" +
                    ids.join(",") +
                    "&pageIndex=1&pageSize=8&recordTotal=8"
                )
                .then(function(res) {
                  var relatedVedioList = res.data.list;

                  $this.$http
                    .get(
                      "/api/stat/getRankingList?type=2&pageIndex=1&pageSize=30"
                    )
                    .then(function(response) {
                      if (response.data) {
                        var hotList = [];
                        if (response.data.list.length) {
                          hotList = $this.getRandomArrayElements(
                            response.data.list,
                            3
                          );
                        }
                        $this.recommendVedioList = $this.getRandomArrayElements(
                          response.data.list,
                          20
                        );
                        $this.relatedVedioList = hotList.concat(
                          relatedVedioList
                        );
                        if ($this.relatedVedioList.length) {
                          for (
                            let i = 0;
                            i < $this.relatedVedioList.length;
                            i++
                          ) {
                            if (
                              $this.relatedVedioList[i].videoId ==
                              $this.$query.id
                            ) {
                              $this.relatedVedioList.splice(i, 1);
                            }
                          }
                        }
                      }
                    });
                });
            }
          });
      }
    },
    makeQrcode() {
      this.qrcode = new QRCode(document.querySelector("#qrcode1"), {
        width: 150,
        height: 150, // 高度
        text: this.config.share_url, // 二维码内容
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    getRandomArrayElements(arr, count) {
      var shuffled = arr.slice(0),
        i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    min(i) {
      this.isMin = i;
      window.removeEventListener("scroll", this.showIcon, false);
    },
    showIcon() {
      var newLeft = document.getElementsByClassName("newLeft")[0];
      if (newLeft) {
        if (
          document.documentElement.scrollTop &&
          document.documentElement.scrollTop > newLeft.offsetHeight + 88
        ) {
          this.isMin = true;
        } else {
          this.isMin = false;
        }
      }
    },
    videoMark() {
      var videoItem = this.videoItem;
      var qiniuMarkData = videoItem.qiniuMarkData;
      if (!qiniuMarkData || (qiniuMarkData && !qiniuMarkData.resource)) {
        this.$http
          .get("/api/video/addMark/" + this.videoItem.videoId)
          .then(res => {
            if (res.data) {
              var url =
                "https://video.manamana.net/" +
                JSON.parse(res.data).resource.s720 +
                "?attname=" +
                encodeURIComponent(videoItem.title) +
                ".mp4";
              var a = document.createElement("a");
              a.setAttribute("href", url);
              // a.href = url
              a.click();
            } else {
              this.$message.success(
                this.$t("video.视频正在转码中，请耐心等待1～2分钟后再尝试")
              );
            }
          });
      } else {
        var url =
          "https://video.manamana.net/" +
          qiniuMarkData.resource.s720 +
          "?attname=" +
          encodeURIComponent(videoItem.title) +
          ".mp4";
        var a = document.createElement("a");
        a.setAttribute("href", url);
        // a.href = url
        a.click();
      }
      // this.$http.get("/api/video/detail?videoId=" + this.$query.id).then((response)=>{
      //   var videoItem = this.$pureData(response.data);
      //   var qiniuMarkData = null;
      //   if (videoItem.qiniuMarkData) {
      //     qiniuMarkData = JSON.parse(videoItem.qiniuMarkData)
      //   }
      //   if (videoItem.allowDownload == 1 && qiniuMarkData && !qiniuMarkData.resource) {
      //     this.$http.get("/api/video/addMark/" + this.videoItem.videoId).then((res)=>{
      //       this.$message.success(this.$t("video.视频正在转码中，请耐心等待1～2分钟后再尝试"));
      //     })
      //   } else if (videoItem.allowDownload == 1 &&qiniuMarkData && qiniuMarkData.resource){
      //     var url = 'https://video.manamana.net/' + qiniuMarkData.resource.s720 + "?attname=" + videoItem.title
      //     var a = document.createElement('a')
      //     a.setAttribute('href',url)
      //     // a.href = url
      //     a.click()
      //   }
      // })
    },
    collectLook(lookDetails) {
      if (lookDetails.isCollect) {
        this.$http.delete("/api/u/fav/collect/" + lookDetails.id).then(res => {
          if (res.code === "OK") {
            this.$message.success(this.$t("collect.取消收藏成功！"));
            lookDetails.isCollect = !lookDetails.isCollect;
            if (lookDetails.collectCount > 0) {
              lookDetails.collectCount--;
            }
          }
        });
      } else {
        this.$http.post("/api/u/fav/collectFav/" + lookDetails.id).then(res => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            lookDetails.isCollect = !lookDetails.isCollect;
            lookDetails.collectCount++;
          }
        });
      }
    },
    init() {
      this.buriedPoint(37, this.$query.id);
      this.getLocation();
      this.origin = window.location.origin;
      if (localStorage.getItem("autoplaynext")) {
        this.autoplaynext = localStorage.getItem("autoplaynext");
      }
      this.isLogin = localStorage.getItem("auth_token");
      this.getRecommend();
      this.getData();
      this.getCollectCount();
      this.getVideoHotEvents();
      if (localStorage.getItem("isAutoPlay") != null) {
        if (localStorage.getItem("isAutoPlay") == 1) {
          this.isAutoPlay = true;
        }
        if (localStorage.getItem("isAutoPlay") == 2) {
          this.isAutoPlay = false;
        }
      }
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home"
      });
      window.open(routeData.href, "_blank");
    },
    getFavCollect() {
      this.$http
        .get("/api/fav/recommendFav/" + this.$query.lookId)
        .then(res => {
          if (res.data == 1) {
            this.type = 1;
          } else if (res.data == 2) {
            this.type = 2;
          } else if (!res.data.videoCount) {
            this.type = 4;
          } else {
            this.type = 3;
            this.lookDetails = res.data;
            this.$http
              .get("/api/fav/videos/" + this.$query.lookId)
              .then(res => {
                this.lookVideoList = res.data.list;
                this.setLookNextId();
              });
            // this.init();
          }
        });
    },
    setLookNextId() {
      for (let i = 0; i < this.lookVideoList.length; i++) {
        if (this.lookVideoList[i].id == this.$query.id) {
          this.lookIndex = i + 1;
          if (i + 2 > this.lookVideoList.length) {
            this.lookList.push(this.lookVideoList[0]);
          } else {
            this.lookList.push(this.lookVideoList[i + 1]);
          }
          this.$nextTick(() => {
            setTimeout(() => {
              let div = document.getElementsByClassName("videoListBox")[0];
              let a = document.getElementsByClassName("lookActive")[0];
              let parentH = div.offsetHeight;
              let acDivH = a.offsetTop - div.offsetTop;
              if (acDivH > parentH / 2) {
                div.scrollTop = acDivH - parentH / 2 + 38;
              } else {
                div.scrollTop = 0;
              }
            }, 50);
          });
          return;
        }
      }
    }
  },

  created() {
    if (this.$query.lookId) {
      this.getFavCollect();
    }
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
    if (!this.$query.lookId) {
      this.playEnd();
    }
    this.$nextTick(() => {
      document.onkeydown = e => {
        if (e.which == "32" || e.which == "37" || e.which == "39") {
          if (
            e.target.localName == "textarea" ||
            e.target.localName == "input"
          ) {
          } else {
            e.preventDefault();
            this.$refs.manaPlayer.setHotKeys(e);
          }
        }
      };
    });
  },
  beforeCreate() {
    window._bd_share_main = "";
  },
  watch: {
    autoplaynext() {
      localStorage.setItem("autoplaynext", this.autoplaynext + "");
    },
    $route(to, from) {
      this.relatedVedioList = [];
      this.lookList = [];
      this.commentList = [];
      this.commentListLength = null;
      this.init();
      if (
        from.query.lookId &&
        to.query.lookId &&
        from.query.lookId == to.query.lookId
      ) {
        this.setLookNextId();
      } else if (this.$query.lookId) {
        this.getFavCollect();
      }
      window.addEventListener("scroll", this.showIcon);
    },
    nametext(newVal, oldVal) {
      if (newVal && newVal.length > 40) {
        this.nametext = oldVal;
      }
    },
    favoritesIds(val) {
      let index = 0;
      let data1 = this.$pureData(val);
      let data2 = this.$pureData(this.createIds);
      if (data1.length == data2.length && data1.length > 0) {
        for (let i = 0; i < data1.length; i++) {
          for (let j = 0; j < data2.length; j++) {
            if (data1[i] == data2[j]) {
              index++;
            }
          }
        }
        if (index == data2.length) {
          this.isLook = true;
        } else {
          this.isLook = false;
        }
      } else if (data1.length == data2.length) {
        this.isLook = true;
      } else {
        this.isLook = false;
      }
    }
  },
  computed: {
    commentWordSum() {
      return 5000 - this.commentContent.length >= 0
        ? 5000 - this.commentContent.length
        : 0;
    },
    language() {
      return this.$language();
    }
  }
};
</script>
<style>
.el-popover {
  min-width: auto;
  padding: 12px !important;
}
.bdshare-button-style1-16 a {
  padding-left: 0 !important;
}
</style>

<style scoped>
.video-container {
  background-color: #ffffff;
  min-width: 1280px;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

@media screen and (max-width: 1280px) {
  .video-wrap {
    width: 1110px;
    margin: 0 auto;
  }

  .left-container {
    width: 760px;
  }

  .top-left {
    height: 453px;
  }

  .newLeft {
    width: 805px;
    height: 513px;
  }

  .comment .el-textarea {
    width: 710px;
  }

  .top-right .top-right-top-list {
    height: 450px;
  }

  .photoAlbum ul li {
    width: 100px;
    height: 100px;
  }

  .photoAlbum ul li span {
    line-height: 100px;
  }

  .vedio-name.video-other {
    width: 230px;
  }

  .vedio-name.video-other:nth-child(3n) {
    margin-right: 0;
  }
}

/*播放器高度开始*/
@media screen and (max-width: 1370px) and (min-width: 1280px) {
  .top-right .top-right-top-list {
    height: 450px;
  }
}

@media screen and (max-width: 1540px) and (min-width: 1370px) {
  .top-right .top-right-top-list {
    height: 540px;
  }
}

@media screen and (max-width: 1700px) and (min-width: 1540px) {
  .top-right .top-right-top-list {
    height: 630px;
  }
}

@media screen and (min-width: 1700px) {
  .top-right .top-right-top-list {
    height: 720px;
  }
}
/*播放器高度结束*/

/*多个创作者宽度开始*/
@media screen and (max-width: 1505px) and (min-width: 1280px) {
  .vedio-name.video-other {
    width: calc((100vw - 550px) / 3);
  }

  .vedio-name.video-other:nth-child(3n) {
    margin-right: 0;
  }
}

@media screen and (max-width: 1760px) and (min-width: 1505px) {
  .vedio-name.video-other {
    width: calc((100vw - 585px) / 4);
  }

  .vedio-name.video-other:nth-child(4n) {
    margin-right: 0;
  }
}

@media screen and (min-width: 1760px) {
  .vedio-name.video-other {
    width: 293px;
  }

  .vedio-name.video-other:nth-child(4n) {
    margin-right: 0;
  }
}
/*多个创作者宽度结束*/

@media screen and (max-width: 1760px) and (min-width: 1280px) {
  .video-wrap {
    width: calc(100vw - 130px);
    margin: 0 65px;
  }

  .left-container {
    width: calc(100vw - 480px);
  }

  .top-left {
    height: calc((100vw - 435px) / 16 * 9);
  }

  .newLeft {
    width: calc(100vw - 435px);
    height: calc((100vw - 435px) / 16 * 9 + 60px);
  }

  .comment .el-textarea {
    width: calc(100vw - 530px);
  }

  .photoAlbum ul li {
    width: calc((100vw - 540px) / 7);
    height: calc((100vw - 540px) / 7);
  }

  .photoAlbum ul li span {
    line-height: calc((100vw - 540px) / 7);
  }
}

@media screen and (min-width: 1760px) {
  .video-wrap {
    width: 1630px;
    margin: 0 auto;
  }

  .left-container {
    width: 1280px;
  }

  .top-left {
    height: 745px;
  }

  .newLeft {
    width: 1325px;
    height: 805px;
  }

  .comment .el-textarea {
    width: 1230px;
  }

  .photoAlbum ul li {
    width: 174px;
    height: 174px;
  }

  .photoAlbum ul li span {
    line-height: 174px;
  }
}

.overHiden {
  overflow: hidden;
  height: 100%;
}
.minVideoPlay {
  position: fixed;
  width: 350px;
  height: 197px;
  bottom: 40px;
  right: 84px;
  z-index: 11;
}
.photoBox {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  padding: 136px 0 70px 0;
  box-sizing: border-box;
}
.photoBox .close {
  position: absolute;
  top: 70px;
  right: 85px;
  width: 44px;
  height: 44px;
  cursor: pointer;
  z-index: 999999;
}
.photoBox .close img {
  width: 44px;
  height: 44px;
}
.photoBox .page {
  position: absolute;
  bottom: 25px;
  left: 50%;
  width: 40px;
  margin-left: -20px;
  font-size: 20px;
  color: #999999;
  text-align: center;
}
.category {
  padding-right: 10px;
  cursor: pointer;
}
.left-container {
  float: left;
  padding-top: 20px;
}

.pic-container {
  width: calc(100vw - 298px);
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;
  height: 100%;
}

.swiper-container {
  height: 100%;
}

.swiper-button-prev {
  background: none;
  font-size: 0.5rem;
  color: #fff;
  z-index: 1011;
  left: 85px;
  top: 50%;
  width: 44px;
  height: 44px;
  margin-top: -22px;
}

.swiper-button-next {
  background: none;
  font-size: 0.5rem;
  color: #fff;
  z-index: 1011;
  right: 85px;
  top: 50%;
  width: 44px;
  height: 44px;
  margin-top: -22px;
}

.swiper-slide {
  display: table;
}

.videm-img-wrap {
  display: table-cell;
  vertical-align: middle;
  height: calc(100vh - 140px);
}

.videoImg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
}

.noimage {
  display: block;
  margin: 0 auto;
  height: 533px;
}

.top-left {
  width: 100%;
  position: relative;
}

.top-left video,
.top-left .video-player {
  width: 100%;
  height: 100%;
}

.top-left iframe {
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

.top-right {
  box-sizing: border-box;
  overflow: hidden;
}

.section-title {
  overflow: hidden;
  zoom: 1;
  line-height: 0.3rem;
  position: relative;
}

.section-title .autoPlay {
  float: right;
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.section-title .viewAll {
  float: right;
  font-size: 14px;
  font-weight: 400;
  color: rgba(10, 10, 10, 1);
  margin-right: 12px;
}

.section-title .viewAll:hover {
  border-bottom: 1px solid #0a0a0a;
}

.section-title .right_icon {
  position: absolute;
  background: url("/static/v2/match/view_all_tri.png");
  width: 7px;
  height: 9px;
  background-size: 100% 100%;
  right: 0;
  top: 5px;
}

.title-span {
  color: #0a0a0a;
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  width: 180px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.title-switch {
  font-size: 0.14rem;
  color: #777777;
  float: right;
}

.top-right-top-list {
  overflow: hidden;
}
.top-right-top-list .hot {
  height: 126px;
  margin-top: 20px;
  display: inline-block;
  margin-bottom: 10px;
}
.top-right-top-list .hot .img {
  float: left;
  width: 95px;
  height: 126px;
  position: relative;
  margin-right: 10px;
}
.top-right-top-list .hot .img .now {
  position: absolute;
  width: 70px;
  height: 24px;
  background: rgba(254, 86, 48, 1);
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 24px;
  top: 6px;
  right: -48px;
}
.top-right-top-list .hot .img .soon {
  position: absolute;
  width: 70px;
  height: 24px;
  background: rgba(32, 38, 204, 1);
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 24px;
  top: 6px;
  right: -48px;
}
.top-right-top-list .hot .img img {
  width: 100%;
  height: 100%;
}
.top-right-top-list .hot .title {
  float: right;
  width: 180px;
}
.top-right-top-list .hot .title .title1 {
  max-height: 42px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  text-overflow: -o-ellipsis-lastline;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 180px;
  margin-top: 44px;
  margin-bottom: 8px;
}
.top-right-top-list .hot .title .title1:hover {
  color: rgba(10, 10, 10, 1);
}
.top-right-top-list .hot .title .title2 {
  height: 19px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 19px;
}
.item {
  overflow: hidden;
  zoom: 1;
  height: 70px;
  margin-top: 20px;
}

.item:first-child {
  border-top: none;
}

.item-left {
  width: 124px;
  height: 70px;
  float: left;
  -webkit-border-radius: 0.05rem;
  -moz-border-radius: 0.05rem;
  border-radius: 0.05rem;
}

.item-left > img {
  display: block;
  width: 100%;
  height: 70px;
}

.item-right {
  float: left;
  margin-left: 10px;
  width: 140px;
  font-size: 0;
}

.item-title {
  display: inline-block;
  width: 100%;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-title:hover {
  color: rgba(10, 10, 10, 1);
}
.item-middle {
  font-size: 12px;
  color: #999;
  margin: 3px 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 18px;
}

.item-bottom {
  margin-bottom: 5px;
  height: 18px;
}

.play-times-icon {
  display: inline-block;
  width: 0.14rem;
  height: 0.16rem;
  background: url("/static/vedio/playtimes.png") no-repeat center center;
  background-size: contain;
  vertical-align: middle;
  margin-right: 0.02rem;
}

.play-times {
  vertical-align: middle;
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-right: 8px;
}

.item-line {
  display: inline-block;
  width: 0.02rem;
  height: 0.14rem;
  vertical-align: middle;
  margin: 0 0.1rem;
  background-color: #444444;
}

.time-icon {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("/static/vedio/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: middle;
  margin-right: 0.02rem;
}

.time {
  vertical-align: middle;
}

.item-bottom-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.item-name {
  width: 100%;
  font-size: 12px;
  color: #666;
  font-weight: bold;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.item-name:hover {
  color: rgba(10, 10, 10, 1);
}

.top-right-top-more {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #777777;
  background-color: #333333;
  cursor: pointer;
}

.top-bottom {
  height: 24px;
  padding: 18px 20px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.06);
}
.top-bottom .reportBut {
  margin-left: 18px;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  cursor: pointer;
}
.top-bottom .right {
  float: right;
}
.top-bottom .right a {
  display: inline-block;
  height: 24px;
  margin-left: 20px;
  font-size: 14px;
}
.top-bottom .right a.color {
  color: rgba(32, 38, 204, 1);
}
.top-bottom .right .share {
  position: relative;
  top: -2px;
  display: inline-block;
  margin-left: 20px;
  height: 38px;
}
.top-bottom .right .more {
  position: relative;
  top: -2px;
}
.top-bottom a {
  color: #666666;
  cursor: pointer;
}
.top-bottom a:hover {
  color: rgba(10, 10, 10, 1);
}

.top-bottom a.add {
  display: inline-block;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: 1px solid rgba(32, 38, 204, 1);
  color: #2026cc;
  font-size: 12px;
  font-weight: 600;
}
.top-bottom a.add:hover {
  background: rgba(32, 38, 204, 0.08);
}
.top-bottom a.download {
  display: inline-block;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: 1px solid rgba(32, 38, 204, 1);
  color: #2026cc;
  font-size: 12px;
  margin: 0 18px 0 10px;
  cursor: pointer;
  font-weight: 600;
}
.top-bottom a.download:hover {
  background: rgba(32, 38, 204, 0.08);
}
.top-bottom a.download1 {
  display: inline-block;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: 1px solid rgba(224, 224, 224, 1);
  color: rgba(184, 184, 184, 1);
  font-size: 12px;
  margin: 0 18px 0 10px;
  cursor: default;
  font-weight: 600;
}
.NoDownloading {
  font-size: 12px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.top-bottom-icon {
  display: inline-block;
  vertical-align: middle;
}
.top-bottom-icon.icon-weibo {
  background: url("/static/video/share_weibo_34@2x.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 34px;
}
.top-bottom-icon.icon-weibo:hover {
  background: url("/static/v2/match/share_weibo_hover.png") no-repeat center
    center;
  background-size: contain;
  width: 34px;
  height: 34px;
  opacity: 1;
}
.top-bottom-icon.icon-wechat {
  background: url("/static/video/share_wechat_34@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 34px;
  height: 34px;
}
.top-bottom-icon.icon-wechat:hover {
  background: url("/static/v2/match/share_wechat_hover.png") no-repeat center
    center;
  background-size: contain;
  width: 34px;
  height: 34px;
  opacity: 1;
}

.top-bottom-icon.icon-qq {
  background: url("/static/video/share_qq_34@2x.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 34px;
}
.top-bottom-icon.icon-qq:hover {
  background: url("/static/v2/match/share_qq_hover.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 34px;
  opacity: 1;
}

.top-bottom-icon.icon-twi {
  background: url("/static/video/share_twitter_34@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 34px;
  height: 34px;
}
.top-bottom-icon.icon-twi:hover {
  background: url("/static/v2/match/share_twitter_hover.png") no-repeat center
    center;
  background-size: contain;
  width: 34px;
  height: 34px;
  opacity: 1;
}
.top-bottom-icon.icon-face {
  background: url("/static/video/share_fb_34@2x.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 34px;
}
.top-bottom-icon.icon-face:hover {
  background: url("/static/v2/match/share_fb_hover.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 34px;
  opacity: 1;
}

.top-bottom-icon.icon-code {
  background: url("/static/video/video_share.png") no-repeat center center;
  background-size: contain;
  width: 34px;
  height: 24px;
  cursor: pointer;
  margin-bottom: 7px;
}

.top-bottom-icon.icon-more {
  background: url("/static/video/video_more@2x.png") no-repeat center center;
  background-size: contain;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.top-bottom-line {
  display: inline-block;
  width: 0.01rem;
  height: 0.2rem;
  background-color: #444444;
  vertical-align: middle;
  margin: 0 0.32rem;
}

.top-bottom-btn {
  width: 1.15rem;
  height: 0.3rem;
  line-height: 0.3rem;
  padding: 0;
  text-align: center;
  -webkit-border-radius: 0.15rem;
  -moz-border-radius: 0.15rem;
  border-radius: 0.15rem;
  background-color: #333333;
  color: #777777;
  font-size: 0.16rem;
  border: none;
  margin-right: 0.1rem;
}

.link-icon {
  display: inline-block;
  vertical-align: text-bottom;
}

.link-icon.link-icon-jubao {
  background: url("/static/vedio/jubao.png") no-repeat center center;
  background-size: contain;
  width: 0.22rem;
  height: 0.22rem;
  cursor: pointer;
}

.commentReport {
  position: absolute;
  right: 0;
}

.top-bottom .link-icon.link-icon-download {
  background: url("/static/video/download.png") no-repeat center center;
  background-size: contain;
  width: 0.24rem;
  height: 0.24rem;
}
.top-bottom .link-icon.link-icon-download1 {
  background: url("/static/video/download_icon@2x.png") no-repeat center center;
  background-size: contain;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-bottom: 3px;
}
.top-bottom .link-icon.link-icon-add {
  background: url("/static/video/add.png") no-repeat center center;
  background-size: contain;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-bottom: 3px;
}
.top-bottom .link-icon.link-icon-photos {
  background: url("/static/video/photos.png") no-repeat center center;
  background-size: contain;
  width: 20px;
  height: 20px;
}
.top-bottom .link-icon.link-icon-photos:hover {
  background: url("/static/video/photos_icon_hover@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 20px;
  height: 20px;
}
.top-bottom .link-icon.link-icon-clap {
  background: url("/static/video/video_clap@2x.png") no-repeat center center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-clap:hover {
  background: url("/static/video/video_clap_hover@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-clap-active {
  background: url("/static/video/video_clap_actived@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-more {
  background: url("/static/video/video_more.png") no-repeat center center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-save {
  background: url("/static/video/video_save@2x.png") no-repeat center center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-save:hover {
  background: url("/static/video/video_save_hover@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-save-active {
  background: url("/static/video/video_save_actived@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 24px;
  height: 24px;
}
.top-bottom .link-icon.link-icon-share {
  background: url("/static/video/video_share.png") no-repeat center center;
  background-size: contain;
  width: 24px;
  height: 24px;
}

.switch {
  width: 2.83rem;
  height: 0.55rem;
  margin: 0.37rem auto 0;
  background: #fff;
  border-radius: 0.4rem;
  display: flex;
}

.switch > span {
  display: inline-block;
  width: 1.4rem;
  height: 0.55rem;
  line-height: 0.55rem;
  color: #333;
  font-size: 0.2rem;
  border-radius: 0.3rem;
  text-align: center;
  cursor: pointer;
  background-color: transparent;
}

.switch > span:last-child {
  margin-left: -0.03rem;
}

.switch > .switchChoose {
  background-color: #0060ff;
  color: #fff;
}

.right-container {
  float: left;
  width: 285px;
  margin: 20px 0 0 65px;
}

.middle-left {
  margin-top: 25px;
}

.middle-left-2 {
  margin-top: 0.2rem;
  padding-bottom: 0.1rem;
}

.title {
  font-size: 24px;
  color: #0a0a0a;
  float: left;
  font-weight: bold;
}

.title .tip {
  font-size: 12px;
  color: #3664ed;
  background: rgba(54, 100, 237, 0.1);
  box-sizing: border-box;
  padding: 0 5px;
  text-align: center;
  line-height: 18px;
  margin-left: 10px;
  display: inline-block;
  vertical-align: middle;
}

.function {
  float: right;
  font-size: 0.22rem;
  color: #595a57;
  line-height: 0.3rem;
}

.function > label:hover {
  cursor: pointer;
}

.favourite-icon {
  width: 0.3rem;
  height: 0.26rem;
  vertical-align: top;
  font-size: 0.33rem;
  margin-right: 0.1rem;
}

.favourite-icon-active {
  color: #0060ff;
}

.recommend-icon {
  width: 0.3rem;
  height: 0.3rem;
  font-size: 0.36rem;
  vertical-align: top;
}

.recommend-icon-active {
  color: #0060ff;
}

.recommend {
  margin-left: 0.4rem;
}

.vedio-content {
  font-size: 14px;
  color: #999;
  clear: both;
  padding-top: 10px;
}
.new_list {
  margin: 15px 0;
}
.new_list .value {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  background: rgba(32, 38, 204, 0.1);
  font-size: 13px;
  color: #2026cc;
  font-weight: 600;
}
.new_list .value img {
  width: 15px;
  height: 15px;
  vertical-align: text-top;
}
.new_tag {
  margin: 20px 0 10px;
}
.new_tag img {
  width: 20px;
  height: 20px;
  vertical-align: text-top;
}
.new_tag .tag {
  display: inline-block;
  padding: 0 10px;
  line-height: 26px;
  background: rgba(245, 245, 245, 1);
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.new_tag .tag:hover {
  color: rgba(32, 38, 204, 1);
}
.vedio-content .value {
  color: #666;
}
.vedio-content .value:hover {
  color: rgba(10, 10, 10, 1);
}

.vedio-content .line {
  display: inline-block;
  vertical-align: middle;
  height: 12px;
  width: 1px;
  background-color: #e0e0e0;
  margin: 0 14px 0 4px;
}
.vedio-name {
  margin-top: 20px;
}
.vedio-name .name {
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  margin: 0 6px 0 4px;
}
.vedio-name .time {
  font-size: 12px;
  color: #999999;
  vertical-align: baseline;
}
.vedio-name .viewCount {
  font-size: 12px;
  font-weight: 400;
  color: rgba(184, 184, 184, 1);
  margin-left: 20px;
}
.vedio-name .viewCount .img-view {
  display: inline-block;
  width: 18px;
  height: 12px;
  margin-bottom: 4px;
  margin-right: 4px;
}

.box:after {
  content: "";
  display: block;
  clear: both;
}
.vedio-name.video-other {
  display: inline-block;
  position: relative;
  padding-left: 60px;
  margin: 10px 35px 0 0;
  min-height: 76px;
  box-sizing: border-box;
  vertical-align: top;
}
.vedio-name.video-other .userType2::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  background: url("/static/v2/match/Verified_icon_blue_20.png");
  background-size: 16px;
  z-index: 1;
  right: 0;
  bottom: 0;
}
.vedio-name.video-other .img {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 50px;
  height: 50px;
}
.vedio-name.video-other .vedio-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid rgba(245, 245, 245, 1);
}

.vedio-name.video-other .vedio-name-center-top {
  width: 100%;
  vertical-align: middle;
  display: inline-block;
}

.vedio-name.video-other .vedio-name-center-top .name {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  line-height: 115%;
  /* text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; */
}
.vedio-name.video-other .vedio-name-center-top .name:hover {
  color: rgba(10, 10, 10, 1);
}
.vedio-name.video-other .vedio-name-center-top .role {
  color: #999;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.vedio-name.video-other .vedio-name-center-top.has-role .name {
  line-height: 26px;
}

.vedio-name.video-other .vedio-name-center-top.has-role .role {
  line-height: 24px;
}

.video-other-title {
  width: 60px;
  height: 28px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 28px;
  margin-top: 20px;
}

.box {
  margin-bottom: 40px;
}

.vedio-avatar {
  width: 28px;
  height: 28px;
  vertical-align: middle;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: 1px solid #f5f5f5;
}

.vedio-name-center {
  vertical-align: middle;
  float: left;
  margin-top: 0.28rem;
  margin-left: 0.2rem;
}

.vedio-name-center-top {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.vedio-name-center-bottom {
  font-size: 0.16rem;
  color: #777777;
  margin-top: 0.05rem;
}

.vedio-name-focus {
  display: inline-block;
  width: 60px;
  padding: 0;
  text-align: center;
  line-height: 24px;
  border: 1px solid rgba(32, 38, 204, 1);
  color: #2026cc;
  font-size: 12px;
  cursor: pointer;
  margin-right: 20px;
  font-weight: 600;
  background: none;
  box-sizing: border-box;
}

.vedio-name-focus.vedio-name-focusd {
  color: rgba(184, 184, 184, 1);
  border: 1px solid rgba(184, 184, 184, 1);
}
.vedio-name-focus.vedio-name-focusd-hover {
  border: 1px solid rgba(153, 153, 153, 1);
  font-size: 12px;
  font-weight: 600;
  color: rgba(153, 153, 153, 1);
}

.vedio-intro {
  margin-top: 40px;
}

.vedio-intro .software {
  margin-top: 20px;
  border: 1px solid rgba(235, 235, 235, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  padding: 15px 0 6px 20px;
}
.vedio-intro .software .video_Tags {
  margin-bottom: 9px;
}
.vedio-intro .software .video_Tags a {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.vedio-intro .software a:hover {
  color: #0a0a0a;
}
.intro-title {
  width: 40px;
  height: 28px;
  font-size: 20px;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 28px;
  margin-bottom: 20px;
}

.intro-content {
  font-size: 14px;
  color: #333333;
  table-layout: fixed;
  word-break: break-word;
  overflow: hidden;
  line-height: 24px;
}
.intro-content >>> img {
  width: 100%;
  height: 100%;
}
.intro-content >>> section {
  max-width: 100%;
}
.intro-content >>> p {
  max-width: 100%;
}

.middle-left-2-1 {
  height: 2.9rem;
  color: #000;
  font-size: 0.2rem;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
  margin: 0 -0.6rem;
  overflow: hidden;
  zoom: 1;
}

.middle-left-2-1 span {
  color: #0060ff;
  text-decoration: underline #0060ff;
  cursor: pointer;
}

.middle-left-2-1.logout {
  text-align: center;
  padding-top: 1.38rem;
}

.middle-left-2-1.login .typearea {
  margin: 0 0.6rem;
  position: relative;
}

.middle-left-2-1.login .typearea textarea {
  height: 1.6rem;
  border: 1px solid #eeeeee;
  outline: none;
  background-color: #f9f9f9;
  font-size: 0.14rem;
  color: #999999;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.18rem;
  resize: none;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.middle-left-2-1.login .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
  text-decoration: none;
}

.comment-btn {
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 1.52rem;
  height: 0.46rem;
  line-height: 0.42rem;
  border: 0.02rem solid #0161ff;
  font-size: 0.18rem;
  color: #0161ff;
  text-align: center;
  background-color: #fff;
  -webkit-border-radius: 0.21rem;
  -moz-border-radius: 0.21rem;
  border-radius: 0.23rem;
  float: right;
  margin-right: 0.6rem;
  margin-top: 0.24rem;
}

.middle-left-2-2 {
  padding-top: 0.18rem;
}

.middle-left-2-2 .sum {
  font-size: 0.18rem;
  color: #777;
}

.middle-left-2-2 .sum span {
  font-size: 0.22rem;
  color: #333;
}

.comment-item {
  padding: 0.4rem 0;
  border-bottom: 1px solid #eeeeee;
  clear: both;
}

.comment-item-content {
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.comment-avatar {
  width: 0.5rem;
  height: 0.5rem;
  float: left;
  border-radius: 0.4rem;
}

.comment-middle {
  margin-left: 0.18rem;
  float: left;
  width: 7rem;
  overflow: hidden;
  zoom: 1;
}

.comment-name {
  font-size: 0.18rem;
  color: #333;
  vertical-align: bottom;
  font-weight: bold;
  display: inline-block;
}

.comment-time {
  font-size: 0.16rem;
  color: #999;
  vertical-align: bottom;
}

.comment-middle-2 {
  font-size: 0.16rem;
  color: #777;
  margin-top: 0.15rem;
  line-height: 0.26rem;
}

.comment-right {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.16rem;
  color: #777;
}

.comment-count,
.ding-count {
  display: inline-block;
}

.comment-count-icon {
  display: inline-block;
  width: 0.18rem;
  height: 0.18rem;
  background: url("/static/vedio/comment.png") no-repeat center center;
  background-size: contain;
  margin-right: 0.1rem;
  vertical-align: top;
  cursor: pointer;
}

.ding-count-icon {
  display: inline-block;
  width: 0.18rem;
  height: 0.18rem;
  margin: -0.03rem 0.1rem 0 0.2rem;
  vertical-align: top;
  cursor: pointer;
  font-size: 0.22rem;
}

.ding-count-icon-active {
  color: #0060ff;
}

.comment-reply {
  clear: both;
  margin-left: 0.68rem;
  margin-top: 0.25rem;
  background-color: #f9f9f9;
  border: 1px solid #eeeeee;
  position: relative;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0.22rem 0.19rem;
}

.comment-reply:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 0.105rem solid transparent;
  border-left: 0.105rem solid transparent;
  border-top: none;
  border-bottom: 0.13rem solid #eeeeee;
  top: -0.13rem;
  left: 0.43rem;
}

.comment-reply:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 0.105rem solid transparent;
  border-left: 0.105rem solid transparent;
  border-top: none;
  border-bottom: 0.13rem solid #f9f9f9;
  top: -0.11rem;
  left: 0.43rem;
}

.comment-reply-form {
  margin-top: 0.2rem;
  padding-left: 0.68rem;
  position: relative;
}

.comment-reply-form textarea {
  border: 1px solid #eeeeee;
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.19rem 0.2rem;
  font-size: 0.16rem;
  color: #777;
  resize: none;
  outline: none;
  height: 1.6rem;
}

.comment-reply-form .typearea {
  position: relative;
}

.comment-reply-form .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
}

.reply-btns {
  text-align: right;
  margin-top: 0.24rem;
}

.reply-btns button {
  width: 1.52rem;
  height: 0.46rem;
  line-height: 0.46rem;
  text-align: center;
  padding: 0;
  -webkit-border-radius: 0.23rem;
  -moz-border-radius: 0.23rem;
  border-radius: 0.23rem;
  border: 0.02rem solid;
  background-color: #fff;
  font-size: 0.18rem;
}

.reply-btns .reply-btn-cancel {
  border-color: #777777;
  color: #777777;
  margin-right: 0.2rem;
}

.reply-btn-yes {
  border-color: #0161ff;
  color: #0161ff;
}

.comment-more {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.18rem;
  color: #0161ff;
  cursor: pointer;
}

.middle-right {
  min-height: 1px;
  margin-top: 70px;
}

.middle-right .item-right {
  margin-top: 13px;
}
.middle-right-1 {
  margin-bottom: 70px;
}
.middle-right-1 .app_promo {
  width: 285px;
  height: 340px;
}

.middle-right-2 {
  margin-top: 0.2rem;
}

.middle-right-title {
  font-size: 0.3rem;
  color: #333333;
  font-weight: bold;
  margin-left: -0.25rem;
  padding-left: 0.25rem;
  position: relative;
}

.middle-right-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.08rem;
  display: block;
  width: 0.06rem;
  height: 0.28rem;
  background-color: #0161ff;
  -webkit-border-radius: 0.03rem;
  -moz-border-radius: 0.03rem;
  border-radius: 0.03rem;
  margin-bottom: 0.3rem;
}

.biaoqian-item {
  display: inline-block;
  padding: 0.08rem 0.2rem;
  font-size: 0.18rem;
  color: #777777;
  margin: 0.1rem 0.05rem;
  border: 1px solid #dddddd;
  -webkit-border-radius: 0.3rem;
  -moz-border-radius: 0.3rem;
  border-radius: 0.3rem;
  max-width: 2.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.biaoqian-item:hover {
  border-color: #0060ff;
  color: #0060ff;
}

.middle-right-subtitle {
  position: absolute;
  right: 0.4rem;
  top: 0.5rem;
  font-size: 0.18rem;
  color: #777;
}

.middle-right-img {
  width: 3.3rem;
  height: 1.88rem;
  display: block;
  -webkit-border-radius: 0.06rem;
  -moz-border-radius: 0.06rem;
  border-radius: 0.06rem;
  margin-top: 0.3rem;
}

.shareCodeContainer1 {
  width: 50px !important;
  height: 30px;
  line-height: 30px;
  text-align: center;
  padding: 0;
  margin: 0;
}
.shareCodeContainer .share a {
  margin-right: 30px;
  display: inline-block;
}
.shareCodeContainer .share a:nth-child(5) {
  margin-right: 0;
}
.shareCodeContainer .video {
  margin-top: 30px;
  font-size: 0;
}
.shareCodeContainer .video p {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(10, 10, 10, 1);
  line-height: 20px;
}
.shareCodeContainer .video input {
  display: inline-block;
  width: 210px;
  height: 30px;
  font-size: 14px;
  font-weight: 400;
}
.shareCodeContainer .video span {
  width: 90px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.shareCodeContainer-row {
  line-height: 0.43rem;
  font-size: 0.16rem;
  color: #000000;
}

.share-tip {
  font-size: 0.2rem;
  display: inline-block;
  width: 0.7rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  color: #fff;
  background-color: #0060ff;
  margin-right: 0.2rem;
}

.sharecode-content {
  width: 210px;
  line-height: 30px;
  border: 1px solid #999999;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  vertical-align: middle;
  padding: 0 5px;
}

.sharecode-btn {
  display: inline-block;
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(32, 38, 204, 1);
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  padding: 0;
  vertical-align: middle;
  border: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.bdsharebuttonbox {
  display: inline-block;
  vertical-align: middle;
}

.report:hover {
  cursor: pointer;
}

.el-dialog__body {
  padding: 0 0.6rem;
  padding-bottom: 0.2rem;
}

.el-dialog {
  border-radius: 0.3rem;
}

.el-form-item__label {
  font-size: 0.2rem;
}

.el-checkbox {
  display: block;
  margin-left: 0 !important;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-form-item {
  margin-bottom: 0;
}

.el-textarea__inner {
  height: 1.4rem;
  border-radius: 0.1rem;
  padding: 0.12rem 0.3rem;
  margin-top: 0.1rem;
}

.el-button {
  width: 1.3rem;
  height: 0.4rem;
  border-radius: 0.3rem;
  line-height: 0.4rem;
  padding: 0;
  margin-top: 0.3rem;
}

.message {
  margin-top: 0.1rem;
  color: #c2c2c2;
}

.photoAlbum p {
  /* width: 80px; */
  height: 28px;
  font-size: 20px;
  font-weight: 600;
  color: rgba(10, 10, 10, 1);
  line-height: 28px;
  margin-bottom: 20px;
  margin-top: 40px;
}

.photoAlbum ul li {
  position: relative;
  margin-right: 10px;
  float: left;
  cursor: pointer;
}

.photoAlbum ul li span {
  position: absolute;
  text-align: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 20px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  background: rgba(10, 10, 10, 0.69);
}

.photoAlbum ul li:last-child {
  margin-right: 0;
}
.photoAlbum ul li img {
  width: 100%;
  height: 100%;
}

.title-switch span {
  outline: none !important;
}

.video-player .video-js {
  width: 100%;
  height: 100%;
}
</style>
<style lang="stylus" scoped>
.comment {
  padding-top: 70px;
  padding-bottom: 100px;

  h4 {
    font-size: 20px;
    font-weight: 600;
    color: #000;
    padding-bottom: 40px;
  }

  .textarea {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;

    img {
      width: 38px;
      height: 38px;
      border-radius: 19px;
      border: 1px solid #f5f5f5;
      margin-right: 10px;
    }

    button {
      background: #2026CC;
      color: #fff;
      height: 30px;
      line-height: 0;
      padding: 5px 17px;
      font-size: 14px;
      font-weight: 600;
      margin-top: 20px;
      border-radius: 0;
      border: none;
    }
  }

  .no-login {
    height: 90px;
    background: #F5F5F5;

    p {
      display: flex;
      justify-content: center;
      padding: 34px;
      font-size: 16px;
      line-height: 22px;
      color: #666666;

      span {
        cursor: pointer;
        color: #0A0A0A;
        font-weight: 600;
        margin: 0 5px;
      }
    }
  }

  .reply-wrap {
    padding-top: 20px;

    &>span {
      font-size: 15px;
      font-weight: 500;
      color: #999999;
    }

    .reply-list {
      &>li {
        padding: 20px 0;
        border-bottom: 1px solid #EBEBEB;
      }

      .children {
        padding: 20px 0 0 50px;

        li {
          padding-bottom: 15px;

          &:last-child {
            padding-bottom: 0;
          }
        }

        .show-more-child {
          color: #2026CC;
          font-size: 14px;
          display: inline-block;
          margin-left: 40px;
          cursor: pointer;

          &::after {
            content: '';
            display: inline-block;
            background: url('/static/v2/article/comment_open_arrow.png');
            background-size: 9px;
            width: 9px;
            height: 9px;
            margin-left: 4px;
          }
        }
      }
    }

    .reply-more {
      padding-top: 50px;
      display: flex;
      justify-content: center;

      div {
        width: 150px;
        height: 40px;
        cursor: pointer;
        border: 1px solid #333;
        text-align: center;

        span {
          color: #0A0A0A;
          font-size: 16px;
          line-height: 40px;
        }
      }
    }

    .reply-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 20px;

      img {
        width: 88px;
        height: 88px;
      }

      span {
        font-size: 15px;
        color: #B8B8B8;
        padding-top: 30px;
      }
    }
  }
}

.zan {
  width: 720px;
  height: 170px;
  border: 1px solid rgba(235, 235, 235, 1);
  padding: 0 20px;
  margin-top: 50px;
  position: relative;

  .zan_number {
    font-size: 16px;
    font-weight: 600;
    color: rgba(10, 10, 10, 1);
    margin: 26px 0 0 10px;

    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }

  .no_like {
    margin-top: 17px;

    .like_title {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      text-align: center;
      margin-bottom: 20px;
    }

    .imgTitle {
      text-align: center;
      width: 140px;
      height: 30px;
      border: 1px solid rgba(32, 38, 204, 1);
      margin: 0 auto;
      line-height: 30px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(32, 38, 204, 1);
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: text-top;
      }
    }
  }
}

.middle-right {
  .middle-right-1 {
    .location {
      width: 285px;
      height: 70px;
      margin: 20px auto 0;
      position: relative;
      cursor: pointer;

      .locationImg {
        width: 100%;
        height: 100%;
        display: inline-block;
      }

      .advertisement {
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 0 4px;
        height: 16px;
        background: rgba(51, 51, 51, 0.4);
        border-radius: 0px 6px 0px 0px;
        line-height: 16px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
<style lang="stylus">
.el-popover {
  min-width: auto;
}

.el-popper-more {
  min-width: auto !important;
}

.content {
  p {
    word-break: break-word;

    &>img {
      margin-bottom: 2px;
    }

    img {
      max-width: 730px;
      height: auto;
    }
  }

  iframe {
    width: 100%;
    height: 400px;
  }
}

.textarea {
  .el-textarea {
    .el-textarea__inner {
      background: #F5F5F5;
      resize: none;
      height: 90px;
      padding: 15px;
      border: none;
      border-radius: 0;
      color: #333;
    }

    .el-textarea__inner:focus {
      border: 1px solid #2026CC;
      backGround: #fff;
      box-sizing: border-box;
    }
  }
}

.createPop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .popBox {
    width: 445px;
    height: 362px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .titleText {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .close {
        position: absolute;
        right: 24px;
        top: 23px;
        width: 13px;
        height: 13px;
      }
    }

    .from {
      padding: 20px 24px 0;

      .name {
        font-size: 15px;
        font-weight: 600;
        color: #333;

        i {
          color: #FE5630;
        }
      }

      .text {
        width: 100%;
        height: 40px;
        margin: 12px 0 20px 0;
        position: relative;

        input {
          display: inline-block;
          width: 100%;
          height: 40px;
          border: 1px solid #E0E0E0;
          padding: 0 50px 0 15px;
          box-sizing: border-box;

          &:focus {
            border: 1px solid #2026CC;
          }
        }

        .numLen {
          position: absolute;
          font-size: 14px;
          font-weight: 400;
          color: #E0E0E0;
          right: 10px;
          height: 21px;
          top: 10px;
          line-height: 21px;
        }
      }

      .select {
        margin-top: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;

        .left {
          float: left;
          margin-right: 30px;
          cursor: pointer;
        }

        .right {
          float: left;
          cursor: pointer;
        }

        .circular {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 1px solid #B8B8B8;
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 10px;
          position: relative;

          .isSele {
            position: absolute;
            width: 10px;
            height: 10px;
            background: #2026cc;
            border-radius: 50%;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
          }
        }

        .cirColor {
          border: 1px solid #2026CC;
        }
      }
    }

    .buttom {
      margin-top: 60px;
      text-align: center;

      .cel {
        width: 90px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #999999;
        display: inline-block;
        margin-right: 20px;
        box-sizing: border-box;
        vertical-align: middle;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        cursor: pointer;
      }

      .cir {
        display: inline-block;
        width: 90px;
        height: 30px;
        line-height: 30px;
        background: #2026CC;
        vertical-align: middle;
        font-size: 14px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
      }
    }

    .popTitle {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      box-sizing: border-box;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .title1 {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        margin-right: 16px;
      }

      .title2 {
        font-size: 12px;
        font-weight: 400;
        color: rgba(32, 38, 204, 0.85);
        cursor: pointer;

        .infoIcon {
          width: 14px;
          height: 14px;
          margin-right: 4px;
          margin-bottom: 2px;
        }
      }

      .close {
        position: absolute;
        right: 24px;
        top: 23px;
        width: 13px;
        height: 13px;
      }
    }

    .from1 {
      padding: 20px 24px 0;
      height: 230px;
      box-sizing: border-box;
      overflow-y: scroll;

      .nameBox {
        margin-bottom: 16px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        position: relative;

        .selectBox {
          display: inline-block;
        }

        img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }

        .textTi {
          display: inline-block;
          max-width: 320px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          vertical-align: middle;
        }

        .textBox {
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 2px solid #B8B8B8;
          box-sizing: border-box;
          vertical-align: middle;
          margin-right: 10px;
        }

        .privateIcon {
          width: 16px;
          height: 16px;
          margin-right: 0;
        }
      }
    }

    .buttom1 {
      border-top: 1px solid #E0E0E0;
      height: 70px;
      padding: 20px 24px;
      box-sizing: border-box;

      .create {
        float: left;
        font-size: 15px;
        font-weight: 400;
        color: #3664ED;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      .butBox {
        float: right;

        .cel {
          width: 90px;
          height: 30px;
          border: 1px solid #999999;
          box-sizing: border-box;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          margin-right: 20px;
          cursor: pointer;
        }

        .cir {
          width: 90px;
          height: 30px;
          background: #2026CC;
          line-height: 30px;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          cursor: pointer;
        }

        .colorCir {
          background: #E0E0E0;
        }
      }
    }
  }
}

.video-container {
  .right-container {
    .top-right {
      .playAllBox {
        width: 285px;
        border: 1px solid #EBEBEB;
        box-sizing: border-box;

        .infoBox {
          padding: 12px 15px;

          .imgBox {
            font-size: 12px;
            font-weight: 400;
            color: #999999;

            .lookIcon {
              width: 20px;
              height: 20px;
              margin-right: 6px;
            }
          }

          .lookName {
            margin: 12px 0 8px 0;
            min-height: 24px;
            font-size: 16px;
            font-weight: 600;
            color: #0A0A0A;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            text-overflow: -o-ellipsis-lastline;
            display: -webkit-box;
            line-clamp: 3;
            -webkit-box-orient: vertical;
          }

          .info {
            height: 26px;
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 26px;

            span {
              color: #666666;
              display: inline-block;
              vertical-align: bottom;
            }

            .name {
              max-width: 80px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              cursor: pointer;
            }

            .collect {
              float: right;
              margin-right: 15px;
              width: 66px;
              height: 26px;
              border: 1px solid #F5F5F5;
              text-align: center;
              box-sizing: border-box;
              position: relative;
              cursor: pointer;

              img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
                margin-bottom: 3px;
              }

              &:hover::after {
                content: attr(data-title);
                display: inline-block;
                padding: 0 10px;
                height: 36px;
                line-height: 36px;
                background: rgba(0, 0, 0, 0.7);
                position: absolute;
                bottom: -45px;
                left: 50%;
                white-space: nowrap;
                transform: translate(-50%);
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
              }
            }

            i {
              margin: 0 5px;
            }
          }
        }

        .videoListBox {
          width: 100%;
          background: #F5F5F5;

          &::-webkit-scrollbar {
            display: none;
          }

          scrollbar-width: none;
          -ms-overflow-style: none;
          overflow-x: hidden;
          overflow-y: auto;

          .videoList {
            height: 60px;
            padding: 8px 12px 8px 0;
            cursor: pointer;

            &:hover {
              background: rgba(0, 0, 0, 0.05);
            }

            .number {
              float: left;
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              line-height: 16px;
              width: 28px;
              text-align: center;
              line-height: 60px;

              img {
                width: 12px;
                height: 12px;
              }
            }

            .imgs {
              float: left;
              width: 106px;
              height: 60px;
              margin-right: 8px;

              img {
                width: 106px;
                height: 60px;
              }
            }

            .infoText {
              float: left;
              width: 128px;

              .videoTitle {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                height: 21px;
                font-size: 14px;
                font-weight: bold;
                color: #333333;
                line-height: 21px;
              }

              .videoTags {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                line-height: 18px;
                margin: 2px 0;
              }

              .videoname {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                height: 18px;
                font-size: 12px;
                font-weight: bold;
                color: #666666;
                line-height: 18px;
              }
            }
          }

          .lookActive {
            background: rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }
}

.isSecretBox {
  width: 100%;
  text-align: center;
  padding: 120px 0 250px 0;

  .secretImg {
    width: 88px;
    height: 88px;
  }

  .secretTitle {
    height: 21px;
    font-size: 15px;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    margin: 8px 0 40px;
  }

  .secretBut {
    display: block;
    margin: 0 auto;
    width: 144px;
    height: 40px;
    background: #2026CC;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    cursor: pointer;
  }
}

.feedbackBox {
  position: relative;
  display: inline-block;
  height: 26px;
  line-height: 26px;

  .reportBut {
    margin-left: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
  }

  .feedback {
    display: none;
    padding: 10px 20px 20px;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    background: #FFFFFF;
    position: absolute;
    top: 32px;
    left: -136px;
    z-index: 111;
    -webkit-box-shadow: 2px -2px 10px rgba(0, 0, 0, 0.1);
    box-shadow: 2px -2px 10px rgba(0, 0, 0, 0.1);

    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: -6px;
      left: 168px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-width: 6px;
      border-style: solid;
      border-color: transparent transparent #fff #fff;
      -webkit-transform: rotate(-46deg);
      -webkit-transform-origin: center;
      transform-origin: center;
      transform: rotate(-46deg);
      -webkit-box-shadow: -3px 2px 2px rgba(255, 255, 255, 0.05);
      box-shadow: -3px 2px 2px rgba(255, 255, 255, 0.05);
      transform: rotate(135deg);
    }

    .feedTitle {
      width: 310px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      height: 30px;
      font-size: 13px;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
      border-bottom: 1px solid #EBEBEB;
    }

    .optionBox {
      margin-top: 21px;
      width: 310px;

      .text {
        float: left;
        font-size: 13px;
        font-weight: 400;
        color: #333333;
        margin: 0 28px 16px 0;
        cursor: pointer;

        span {
          width: 16px;
          height: 16px;
          border: 1px solid #B8B8B8;
          display: inline-block;
          border-radius: 50%;
          margin-right: 5px;
          vertical-align: middle;
          position: relative;

          i {
            position: absolute;
            width: 8px;
            height: 8px;
            background: #2026CC;
            border-radius: 50%;
            top: 4px;
            left: 4px;
          }
        }

        .active {
          border: 1px solid #2026CC;
        }
      }
    }

    .describe {
      .desTitle {
        height: 20px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-bottom: 6px;
      }

      .desInput {
        display: block;
        width: 310px;
        height: 60px;
        border: 1px solid #E0E0E0;
        line-height: 20px;
      }
    }

    .reBut {
      width: 90px;
      height: 30px;
      background: #2026CC;
      margin: 16px auto 0;
      cursor: pointer;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

  &:hover {
    .feedback {
      display: block;
    }
  }
}

.shareCodeContainerBox {
  position: relative;
  display: inline-block;
  height: 26px;
  line-height: 26px;
  margin-left: 16px;

  .shareCodeContainer {
    display: none;
    padding: 10px 20px 20px;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    background: #FFFFFF;
    position: absolute;
    top: 30px;
    left: -156px;
    z-index: 111;
    -webkit-box-shadow: 2px -2px 10px rgba(0, 0, 0, 0.1);
    box-shadow: 2px -2px 10px rgba(0, 0, 0, 0.1);

    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: -6px;
      left: 168px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-width: 6px;
      border-style: solid;
      border-color: transparent transparent #fff #fff;
      -webkit-transform: rotate(-46deg);
      -webkit-transform-origin: center;
      transform-origin: center;
      transform: rotate(-46deg);
      -webkit-box-shadow: -3px 2px 2px rgba(255, 255, 255, 0.05);
      box-shadow: -3px 2px 2px rgba(255, 255, 255, 0.05);
      transform: rotate(135deg);
    }

    .bdsharebuttonbox {
      width: 290px;

      .top-bottom-icon {
        width: 34px;
        height: 34px;
        padding-left: 0;
        margin-right: 30px;
      }

      a {
        margin-left: 0;
      }
    }
  }

  &:hover {
    .shareCodeContainer {
      display: block;
    }
  }
}

@media screen and (max-width: 1760px){
  .playAllBox .videoListBox {
    max-height: 449px !important;
  }
}

@media screen and (min-width: 1760px) {
  .playAllBox .videoListBox {
    max-height: 631px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Video.vue